import React, {FC, useEffect, useRef, useState} from 'react'
import {useLocation, useNavigate} from 'react-router-dom'
import {PageTitle} from '../../../_metronic/layout/core'
import {fetchData, toasterrormsg, toastsuccessmsg} from '../../../reusable'
import {ToastContainer} from 'react-toastify'
import {AddCarRentalHeader} from './AddCarRentalHeader'
import clsx from 'clsx'
import {Tr} from '../../../_metronic/i18n/Tr'
import {useLang} from '../../../_metronic/i18n/Metronici18n'
import {formatDuration} from '../advertisement/bannerAdvertisement/AddAdvertisement.constants'
import Select from 'react-select'
import PriceInput from '../PriceInput'

const AddCarRentalPolicies: FC = () => {
  const t = Tr()
  const lang = useLang()
  const navigate = useNavigate()
  const categoryId = sessionStorage.getItem('categoryId')
  useEffect(() => {
    if (categoryId != '7') {
      navigate('../dashboard/')
    }
  }, [categoryId])
  const divRefEN = useRef(null) as any
  const divRefRU = useRef(null) as any
  const divRefUZ = useRef(null) as any
  const location = useLocation()
  const editCarrentalId = (location.state as any)?.carrentalId || ''
  const [carRentalDetails, setCarRentalDetails] = useState([])
  const [tab, setTab] = useState('1') // 1,2,3,4,5,6,7
  const [policyTab, setPolicyTab] = useState('1')
  const [apiTabs, setApiTabs] = useState(new Set()) as any
  const [apiData, setApiData] = useState({}) as any // Stores original API data per tab
  var vendorId = ''
  const vendorData = sessionStorage.getItem("vendor")
  if (vendorData) {
    var vendor = JSON.parse(vendorData)
    vendorId = vendor.vendorId
  } else {
    console.log('No vendor data found')
  }
  const [loading, setLoading] = useState(false)
  const [disable, setDisable] = useState(false)
  const primaryLanguage = localStorage.getItem('primaryLanguage')
  const [mileagePolicyId, setMileagePolicyId] = useState('')
  const [mileagePolicyEN, setMileagePolicyEN] = useState('')
  const [mileagePolicyRU, setMileagePolicyRU] = useState('')
  const [mileagePolicyUZ, setMileagePolicyUZ] = useState('')
  const [fuelPolicyId, setFuelPolicyId] = useState('')
  const [fuelPolicyEN, setFuelPolicyEN] = useState('')
  const [fuelPolicyRU, setFuelPolicyRU] = useState('')
  const [fuelPolicyUZ, setFuelPolicyUZ] = useState('')
  const [ageRequirementId, setAgeRequirementId] = useState('')
  const [ageRequirementEN, setAgeRequirementEN] = useState('')
  const [ageRequirementRU, setAgeRequirementRU] = useState('')
  const [ageRequirementUZ, setAgeRequirementUZ] = useState('')
  const [additionalDriversId, setAdditionalDriversId] = useState('')
  const [additionalDriversEN, setAdditionalDriversEN] = useState('')
  const [additionalDriversRU, setAdditionalDriversRU] = useState('')
  const [additionalDriversUZ, setAdditionalDriversUZ] = useState('')
  const [outisideBusinessHourId, setOutisideBusinessHourId] = useState('')
  const [outsideOfBusinessHoursEN, setOutsideOfBusinessHoursEN] = useState('')
  const [outsideOfBusinessHoursRU, setOutsideOfBusinessHoursRU] = useState('')
  const [outsideOfBusinessHoursUZ, setOutsideOfBusinessHoursUZ] = useState('')
  const [localFeesId, setLocalFeesId] = useState('')
  const [localFeesEN, setLocalFeesEN] = useState('')
  const [localFeesRU, setLocalFeesRU] = useState('')
  const [localFeesUZ, setLocalFeesUZ] = useState('')
  const [branchNoticeId, setBranchNoticeId] = useState('')
  const [branchNoticeEN, setBranchNoticeEN] = useState('')
  const [branchNoticeRU, setBranchNoticeRU] = useState('')
  const [branchNoticeUZ, setBranchNoticeUZ] = useState('')
  const [securityDepositAmount, setSecurityDepositAmount] = useState('')
  const [aboutDepositsId, setAboutDepositsId] = useState('')
  const [aboutDepositsEN, setAboutDepositsEN] = useState('')
  const [aboutDepositsRU, setAboutDepositsRU] = useState('')
  const [aboutDepositsUZ, setAboutDepositsUZ] = useState('')
  const [earlyPickUpId, setEarlyPickUpId] = useState('')
  const [earlyPickUpEN, setEarlyPickUpEN] = useState('')
  const [earlyPickUpRU, setEarlyPickUpRU] = useState('')
  const [earlyPickUpUZ, setEarlyPickUpUZ] = useState('')
  const [latePickUpId, setLatePickUpId] = useState('')
  const [latePickUpEN, setLatePickUpEN] = useState('')
  const [latePickUpRU, setLatePickUpRU] = useState('')
  const [latePickUpUZ, setLatePickUpUZ] = useState('')
  const [earlyDropOffId, setEarlyDropOffId] = useState('')
  const [earlyDropOffEN, setEarlyDropOffEN] = useState('')
  const [earlyDropOffRU, setEarlyDropOffRU] = useState('')
  const [earlyDropOffUZ, setEarlyDropOffUZ] = useState('')
  const [lateDropOffId, setLateDropOffId] = useState('')
  const [lateDropOffEN, setLateDropOffEN] = useState('')
  const [lateDropOffRU, setLateDropOffRU] = useState('')
  const [lateDropOffUZ, setLateDropOffUZ] = useState('')
  const [confirmationPolicyId, setConfirmationPolicyId] = useState('')
  const [confirmationPolicyEN, setConfirmationPolicyEN] = useState('')
  const [confirmationPolicyRU, setConfirmationPolicyRU] = useState('')
  const [confirmationPolicyUZ, setConfirmationPolicyUZ] = useState('')
  const [contractAmountCheckId, setContractAmountCheckId] = useState('')
  const [contractAmountCheckEN, setContractAmountCheckEN] = useState('')
  const [contractAmountCheckRU, setContractAmountCheckRU] = useState('')
  const [contractAmountCheckUZ, setContractAmountCheckUZ] = useState('')
  const [inspectionGuidelinesId, setInspectionGuidelinesId] = useState('')
  const [inspectionGuidelinesEN, setInspectionGuidelinesEN] = useState('')
  const [inspectionGuidelinesRU, setInspectionGuidelinesRU] = useState('')
  const [inspectionGuidelinesUZ, setInspectionGuidelinesUZ] = useState('')
  const [extrasId, setExtrasId] = useState('')
  const [extrasEN, setExtrasEN] = useState('')
  const [extrasRU, setExtrasRU] = useState('')
  const [extrasUZ, setExtrasUZ] = useState('')
  const [texesAndFeesId, setTexesAndFeesId] = useState('')
  const [texesAndFessEN, setTexesAndFessEN] = useState('')
  const [texesAndFessRU, setTexesAndFessRU] = useState('')
  const [texesAndFessUZ, setTexesAndFessUZ] = useState('')
  // const [modifictionsId, setModifictionsId] = useState("");
  // const [modificationsEN, setModificationsEN] = useState("");
  // const [modificationsRU, setModificationsRU] = useState("");
  // const [modificationsUZ, setModificationsUZ] = useState("");
  // const [noShowsId, setNoShowsId] = useState("");
  // const [noShowsEN, setNoShowsEN] = useState("");
  // const [noShowsRU, setNoShowsRU] = useState("");
  // const [noShowsUZ, setNoShowsUZ] = useState("");
  const [cancellationId, setCancellationId] = useState('')
  const [cancellationEN, setCancellationEN] = useState('')
  const [cancellationRU, setCancellationRU] = useState('')
  const [cancellationUZ, setCancellationUZ] = useState('')
  const [accidentAndBreakDownsId, setAccidentAndBreakDownsId] = useState('')
  const [accidentsAndBreakdownsEN, setAccidentsAndBreakdownsEN] = useState('')
  const [accidentsAndBreakdownsRU, setAccidentsAndBreakdownsRU] = useState('')
  const [accidentsAndBreakdownsUZ, setAccidentsAndBreakdownsUZ] = useState('')
  const [roadsideAssitanceId, setRoadsideAssitanceId] = useState('')
  const [roadsideAssistanceEN, setRoadsideAssistanceEN] = useState('')
  const [roadsideAssistanceRU, setRoadsideAssistanceRU] = useState('')
  const [roadsideAssistanceUZ, setRoadsideAssistanceUZ] = useState('')
  const [lostKeysId, setLostKeysId] = useState('')
  const [lostKeysEN, setLostKeysEN] = useState('')
  const [lostKeysRU, setLostKeysRU] = useState('')
  const [lostKeysUZ, setLostKeysUZ] = useState('')
  const [seatBeltsId, setSeatBeltsId] = useState('')
  const [seatBeltsEN, setSeatBeltsEN] = useState('')
  const [seatBeltsRU, setSeatBeltsRU] = useState('')
  const [seatBeltsUZ, setSeatBeltsUZ] = useState('')
  const [noSmokingId, setNoSmokingId] = useState('')
  const [noSmokingEN, setNoSmokingEN] = useState('')
  const [noSmokingRU, setNoSmokingRU] = useState('')
  const [noSmokingUZ, setNoSmokingUZ] = useState('')
  const [priceCalculationId, setPriceCalculationId] = useState('')
  const [priceCalculationEN, setPriceCalculationEN] = useState('')
  const [priceCalculationRU, setPriceCalculationRU] = useState('')
  const [priceCalculationUZ, setPriceCalculationUZ] = useState('')
  const [violationsId, setViolationsId] = useState('')
  const [violationsEN, setViolationsEN] = useState('')
  const [violationsRU, setViolationsRU] = useState('')
  const [violationsUZ, setViolationsUZ] = useState('')
  const [travelRestricationsId, setTravelRestricationsId] = useState('')
  const [travelRestrictionsEN, setTravelRestrictionsEN] = useState('')
  const [travelRestrictionsRU, setTravelRestrictionsRU] = useState('')
  const [travelRestrictionsUZ, setTravelRestrictionsUZ] = useState('')
  const [isNonRefundable, setIsNonRefundable] = useState(false)
  const [isFreeCancellation, setIsFreeCancellation] = useState(false)

  // Non-refundable and free cancellation are mutually exclusive; both start unselected
  const handleNonRefundableChange = (e: any) => {
    setIsNonRefundable(e.target.checked)
    if (e.target.checked) setIsFreeCancellation(false)
  }
  const handleFreeCancellationChange = (e: any) => {
    setIsFreeCancellation(e.target.checked)
    if (e.target.checked) setIsNonRefundable(false)
  }
  const getInitialBeforeCheckinDaysList = (tab: any) => {
    if (tab === '1') {
      return [{value: '0', label: t('less than 24 hours')}]
    } else if (tab === '5') {
      return createDaysList(4)
    } else if (tab === '14') {
      return createDaysList(13)
    } else if (tab === '30') {
      return createDaysList(29)
    } else {
      return []
    }
  }
  const createDaysList = (days: any) => {
    const list = []
    for (let i = days; i >= 0; i--) {
      list.push({
        value: i.toString(),
        label: i === 0 ? t('less than 24 hours') : formatDuration(i, 'DAY', lang),
      })
    }
    return list
  }

  useEffect(() => {
    setCancellationDay([{cancellationDay: policyTab, fee: fee}])
  }, [policyTab])
  const initialPercentageList = [
    {value: '100', label: `100% ${t('of total price')}`},
    {value: '90', label: `90% ${t('of total price')}`},
    {value: '70', label: `70% ${t('of total price')}`},
    {value: '50', label: `50% ${t('of total price')}`},
  ]

  const [showPolicy, setShowPolicy] = useState(false)
  const togglePolicy = () => {
    setShowPolicy(!showPolicy)
  }

  const [fee, setFee] = useState([{day: '', percentage: ''}])
  const [cancellationDay, setCancellationDay] = useState([{cancellationDay: policyTab, fee: fee}])

  useEffect(() => {
    // Only update `fee` and `cancellationDay` when switching tabs if the current tab isn't from the API
    if (apiTabs.has(policyTab) && apiData[policyTab]) {
      // If the tab has data from the API, use the stored API data
      setFee(apiData[policyTab].fee)
      setCancellationDay(apiData[policyTab].cancellationDay)
    } else {
      // If it's not an API tab, set the default values
      const defaultFee =
        policyTab === '5' || policyTab === '14' || policyTab === '30'
          ? [
              {day: '0', percentage: ''},
              {day: '1', percentage: ''},
            ]
          : [{day: '0', percentage: ''}]

      const defaultCancellationDay = {
        cancellationDay: policyTab,
        fee: defaultFee,
      }

      setFee(defaultFee)
      setCancellationDay([defaultCancellationDay])
    }
  }, [policyTab, apiTabs])

  const handleAddField = () => {
    setFee([...fee, {day: '', percentage: ''}])
  }

  const handleRemoveField = (index: any) => {
    const newFields = fee.filter((_, i) => i !== index)
    setFee(newFields)
    setCancellationDay([{cancellationDay: policyTab, fee: newFields}])
  }

  const handleFieldChange = (index: any, field: any, value: any) => {
    const newFields = [...fee] as any
    newFields[index][field] = value
    setFee(newFields)
    setCancellationDay([{cancellationDay: policyTab, fee: newFields}])
  }

  const filterDaysList = (fields: any) => {
    const selectedDays = fields.map((f: any) => f.day)
    return getInitialBeforeCheckinDaysList(policyTab).filter(
      (day) => !selectedDays.includes(day.value)
    )
  }

  const [errors, setErrors] = useState({
    titleEN: '',
    titleRU: '',
    titleUZ: '',
    policyNameEN: '',
    policyNameRU: '',
    policyNameUZ: '',
    descriptionEN: '',
    descriptionRU: '',
    descriptionUZ: '',
  }) as any

  const [policies, setPolicies] = useState([
    {
      en_title: '',
      ru_title: '',
      uz_title: '',
      en_description: '',
      ru_description: '',
      uz_description: '',
    },
  ])

  useEffect(() => {
    if (divRefEN.current) {
      setCancellationEN(divRefEN.current.innerHTML)
    }
  }, [isNonRefundable, isFreeCancellation, cancellationDay])

  useEffect(() => {
    if (divRefRU.current) {
      setCancellationRU(divRefRU.current.innerHTML)
    }
  }, [isNonRefundable, isFreeCancellation, cancellationDay])

  useEffect(() => {
    if (divRefUZ.current) {
      setCancellationUZ(divRefUZ.current.innerHTML)
    }
  }, [isNonRefundable, isFreeCancellation, cancellationDay])

  const handleAddPolicy = () => {
    setPolicies([
      ...policies,
      {
        en_title: '',
        ru_title: '',
        uz_title: '',
        en_description: '',
        ru_description: '',
        uz_description: '',
      },
    ])
  }

  const handleRemovePolicy = (index: any) => {
    if (policies.length === 1) return // Prevent removing the last row
    const updatedPolicies = policies.filter((_, i) => i !== index)
    setPolicies(updatedPolicies)
    // Clear errors for removed policy
    const updatedErrors = {...errors} as any
    delete updatedErrors[index]
    setErrors(updatedErrors)
  }

  const handlePolicyChange = (index: any, field: any, value: any) => {
    const updatedPolicies = [...policies] as any
    updatedPolicies[index][field] = value
    setPolicies(updatedPolicies)
    // Clear error when user starts typing
    const updatedErrors = {...errors} as any
    delete updatedErrors[index]
    setErrors(updatedErrors)
  }

  // set error state
  const [error, setError] = useState([
    {
      mileagePolicyEN: '',
      mileagePolicyRU: '',
      mileagePolicyUZ: '',
      fuelPolicyEN: '',
      fuelPolicyRU: '',
      fuelPolicyUZ: '',
      ageRequirementEN: '',
      ageRequirementRU: '',
      ageRequirementUZ: '',
      additionalDriversEN: '',
      additionalDriversRU: '',
      additionalDriversUZ: '',
      outsideOfBusinessHoursEN: '',
      outsideOfBusinessHoursRU: '',
      outsideOfBusinessHoursUZ: '',
      localFeesEN: '',
      localFeesRU: '',
      localFeesUZ: '',
      branchNoticeEN: '',
      branchNoticeRU: '',
      branchNoticeUZ: '',
      securityDepositAmount: '',
      aboutDepositsEN: '',
      aboutDepositsRU: '',
      aboutDepositsUZ: '',
      earlyPickUpEN: '',
      earlyPickUpRU: '',
      earlyPickUpUZ: '',
      latePickUpEN: '',
      latePickUpRU: '',
      latePickUpUZ: '',
      earlyDropOffEN: '',
      earlyDropOffRU: '',
      earlyDropOffUZ: '',
      lateDropOffEN: '',
      lateDropOffRU: '',
      lateDropOffUZ: '',
      confirmationPolicyEN: '',
      confirmationPolicyRU: '',
      confirmationPolicyUZ: '',
      contractAmountCheckEN: '',
      contractAmountCheckRU: '',
      contractAmountCheckUZ: '',
      inspectionGuidelinesEN: '',
      inspectionGuidelinesRU: '',
      inspectionGuidelinesUZ: '',
      extrasEN: '',
      extrasRU: '',
      extrasUZ: '',
      texesAndFessEN: '',
      texesAndFessRU: '',
      texesAndFessUZ: '',
      // modificationsEN: '', modificationsRU: '', modificationsUZ: '',
      // noShowsEN: '', noShowsRU: '', noShowsUZ: '',
      cancellationEN: '',
      cancellationRU: '',
      cancellationUZ: '',
      accidentsAndBreakdownsEN: '',
      accidentsAndBreakdownsRU: '',
      accidentsAndBreakdownsUZ: '',
      roadsideAssistanceEN: '',
      roadsideAssistanceRU: '',
      roadsideAssistanceUZ: '',
      lostKeysEN: '',
      lostKeysRU: '',
      lostKeysUZ: '',
      seatBeltsEN: '',
      seatBeltsRU: '',
      seatBeltsUZ: '',
      noSmokingEN: '',
      noSmokingRU: '',
      noSmokingUZ: '',
      priceCalculationEN: '',
      priceCalculationRU: '',
      priceCalculationUZ: '',
      violationsEN: '',
      violationsRU: '',
      violationsUZ: '',
      travelRestrictionsEN: '',
      travelRestrictionsRU: '',
      travelRestrictionsUZ: '',
    },
  ])

  // remove validation function
  const removeError = (err: any) => {
    var tmp = [...error] as any
    tmp[0][err] = ''
    setError(tmp)
  }

  // validation function
  const validate1 = () => {
    var isValid = true
    var errorTmp = [...error]

    if (primaryLanguage == 'English') {
      if (mileagePolicyEN == '' || mileagePolicyEN == null || mileagePolicyEN == undefined) {
        errorTmp[0].mileagePolicyEN = t('Description Is Required')
        isValid = false
      }
      if (fuelPolicyEN == '' || fuelPolicyEN == null || fuelPolicyEN == undefined) {
        errorTmp[0].fuelPolicyEN = t('Description Is Required')
        isValid = false
      }
      if (ageRequirementEN == '' || ageRequirementEN == null || ageRequirementEN == undefined) {
        errorTmp[0].ageRequirementEN = t('Description Is Required')
        isValid = false
      }
      if (
        additionalDriversEN == '' ||
        additionalDriversEN == null ||
        additionalDriversEN == undefined
      ) {
        errorTmp[0].additionalDriversEN = t('Description Is Required')
        isValid = false
      }
      if (
        outsideOfBusinessHoursEN == '' ||
        outsideOfBusinessHoursEN == null ||
        outsideOfBusinessHoursEN == undefined
      ) {
        errorTmp[0].outsideOfBusinessHoursEN = t('Description Is Required')
        isValid = false
      }
      if (localFeesEN == '' || localFeesEN == null || localFeesEN == undefined) {
        errorTmp[0].localFeesEN = t('Description Is Required')
        isValid = false
      }
      if (branchNoticeEN == '' || branchNoticeEN == null || branchNoticeEN == undefined) {
        errorTmp[0].branchNoticeEN = t('Description Is Required')
        isValid = false
      }
      if (aboutDepositsEN == '' || aboutDepositsEN == null || aboutDepositsEN == undefined) {
        errorTmp[0].aboutDepositsEN = t('Description Is Required')
        isValid = false
      }
    } else if (primaryLanguage == 'Russian') {
      if (mileagePolicyRU == '' || mileagePolicyRU == null || mileagePolicyRU == undefined) {
        errorTmp[0].mileagePolicyRU = t('Description Is Required')
        isValid = false
      }
      if (fuelPolicyRU == '' || fuelPolicyRU == null || fuelPolicyRU == undefined) {
        errorTmp[0].fuelPolicyRU = t('Description Is Required')
        isValid = false
      }
      if (ageRequirementRU == '' || ageRequirementRU == null || ageRequirementRU == undefined) {
        errorTmp[0].ageRequirementRU = t('Description Is Required')
        isValid = false
      }
      if (
        additionalDriversRU == '' ||
        additionalDriversRU == null ||
        additionalDriversRU == undefined
      ) {
        errorTmp[0].additionalDriversRU = t('Description Is Required')
        isValid = false
      }
      if (
        outsideOfBusinessHoursRU == '' ||
        outsideOfBusinessHoursRU == null ||
        outsideOfBusinessHoursRU == undefined
      ) {
        errorTmp[0].outsideOfBusinessHoursRU = t('Description Is Required')
        isValid = false
      }
      if (localFeesRU == '' || localFeesRU == null || localFeesRU == undefined) {
        errorTmp[0].localFeesRU = t('Description Is Required')
        isValid = false
      }
      if (branchNoticeRU == '' || branchNoticeRU == null || branchNoticeRU == undefined) {
        errorTmp[0].branchNoticeRU = t('Description Is Required')
        isValid = false
      }
      if (aboutDepositsRU == '' || aboutDepositsRU == null || aboutDepositsRU == undefined) {
        errorTmp[0].aboutDepositsRU = t('Description Is Required')
        isValid = false
      }
    } else if (primaryLanguage == 'Uzbek') {
      if (mileagePolicyUZ == '' || mileagePolicyUZ == null || mileagePolicyUZ == undefined) {
        errorTmp[0].mileagePolicyUZ = t('Description Is Required')
        isValid = false
      }
      if (fuelPolicyUZ == '' || fuelPolicyUZ == null || fuelPolicyUZ == undefined) {
        errorTmp[0].fuelPolicyUZ = t('Description Is Required')
        isValid = false
      }
      if (ageRequirementUZ == '' || ageRequirementUZ == null || ageRequirementUZ == undefined) {
        errorTmp[0].ageRequirementUZ = t('Description Is Required')
        isValid = false
      }
      if (
        additionalDriversUZ == '' ||
        additionalDriversUZ == null ||
        additionalDriversUZ == undefined
      ) {
        errorTmp[0].additionalDriversUZ = t('Description Is Required')
        isValid = false
      }
      if (
        outsideOfBusinessHoursUZ == '' ||
        outsideOfBusinessHoursUZ == null ||
        outsideOfBusinessHoursUZ == undefined
      ) {
        errorTmp[0].outsideOfBusinessHoursUZ = t('Description Is Required')
        isValid = false
      }
      if (localFeesUZ == '' || localFeesUZ == null || localFeesUZ == undefined) {
        errorTmp[0].localFeesUZ = t('Description Is Required')
        isValid = false
      }
      if (branchNoticeUZ == '' || branchNoticeUZ == null || branchNoticeUZ == undefined) {
        errorTmp[0].branchNoticeUZ = t('Description Is Required')
        isValid = false
      }
      if (aboutDepositsUZ == '' || aboutDepositsUZ == null || aboutDepositsUZ == undefined) {
        errorTmp[0].aboutDepositsUZ = t('Description Is Required')
        isValid = false
      }
    }
    if (
      securityDepositAmount.trim() == '' ||
      securityDepositAmount.trim() == undefined ||
      securityDepositAmount.trim() == null
    ) {
      errorTmp[0].securityDepositAmount = t('Deposit Amount Is Required')
      isValid = false
    }
    setError(errorTmp)
    return isValid
  }
  const validate2 = () => {
    var isValid = true
    var errorTmp = [...error]

    if (primaryLanguage == 'English') {
      if (earlyPickUpEN == '' || earlyPickUpEN == null || earlyPickUpEN == undefined) {
        errorTmp[0].earlyPickUpEN = t('Description Is Required')
        isValid = false
      }
      if (latePickUpEN == '' || latePickUpEN == null || latePickUpEN == undefined) {
        errorTmp[0].latePickUpEN = t('Description Is Required')
        isValid = false
      }
      if (earlyDropOffEN == '' || earlyDropOffEN == null || earlyDropOffEN == undefined) {
        errorTmp[0].earlyDropOffEN = t('Description Is Required')
        isValid = false
      }
      if (lateDropOffEN == '' || lateDropOffEN == null || lateDropOffEN == undefined) {
        errorTmp[0].lateDropOffEN = t('Description Is Required')
        isValid = false
      }
    } else if (primaryLanguage == 'Russian') {
      if (earlyPickUpRU == '' || earlyPickUpRU == null || earlyPickUpRU == undefined) {
        errorTmp[0].earlyPickUpRU = t('Description Is Required')
        isValid = false
      }
      if (latePickUpRU == '' || latePickUpRU == null || latePickUpRU == undefined) {
        errorTmp[0].latePickUpRU = t('Description Is Required')
        isValid = false
      }
      if (earlyDropOffRU == '' || earlyDropOffRU == null || earlyDropOffRU == undefined) {
        errorTmp[0].earlyDropOffRU = t('Description Is Required')
        isValid = false
      }
      if (lateDropOffRU == '' || lateDropOffRU == null || lateDropOffRU == undefined) {
        errorTmp[0].lateDropOffRU = t('Description Is Required')
        isValid = false
      }
    } else if (primaryLanguage == 'Uzbek') {
      if (earlyPickUpUZ == '' || earlyPickUpUZ == null || earlyPickUpUZ == undefined) {
        errorTmp[0].earlyPickUpUZ = t('Description Is Required')
        isValid = false
      }
      if (latePickUpUZ == '' || latePickUpUZ == null || latePickUpUZ == undefined) {
        errorTmp[0].latePickUpUZ = t('Description Is Required')
        isValid = false
      }
      if (earlyDropOffUZ == '' || earlyDropOffUZ == null || earlyDropOffUZ == undefined) {
        errorTmp[0].earlyDropOffUZ = t('Description Is Required')
        isValid = false
      }
      if (lateDropOffUZ == '' || lateDropOffUZ == null || lateDropOffUZ == undefined) {
        errorTmp[0].lateDropOffUZ = t('Description Is Required')
        isValid = false
      }
    }

    setError(errorTmp)
    return isValid
  }
  const validate3 = () => {
    var isValid = true
    var errorTmp = [...error]

    if (primaryLanguage == 'English') {
      if (
        confirmationPolicyEN == '' ||
        confirmationPolicyEN == null ||
        confirmationPolicyEN == undefined
      ) {
        errorTmp[0].confirmationPolicyEN = t('Description Is Required')
        isValid = false
      }
      if (
        contractAmountCheckEN == '' ||
        contractAmountCheckEN == null ||
        contractAmountCheckEN == undefined
      ) {
        errorTmp[0].contractAmountCheckEN = t('Description Is Required')
        isValid = false
      }
      if (
        inspectionGuidelinesEN == '' ||
        inspectionGuidelinesEN == null ||
        inspectionGuidelinesEN == undefined
      ) {
        errorTmp[0].inspectionGuidelinesEN = t('Description Is Required')
        isValid = false
      }
    } else if (primaryLanguage == 'Russian') {
      if (
        confirmationPolicyRU == '' ||
        confirmationPolicyRU == null ||
        confirmationPolicyRU == undefined
      ) {
        errorTmp[0].confirmationPolicyRU = t('Description Is Required')
        isValid = false
      }
      if (
        contractAmountCheckRU == '' ||
        contractAmountCheckRU == null ||
        contractAmountCheckRU == undefined
      ) {
        errorTmp[0].contractAmountCheckRU = t('Description Is Required')
        isValid = false
      }
      if (
        inspectionGuidelinesRU == '' ||
        inspectionGuidelinesRU == null ||
        inspectionGuidelinesRU == undefined
      ) {
        errorTmp[0].inspectionGuidelinesRU = t('Description Is Required')
        isValid = false
      }
    } else if (primaryLanguage == 'Uzbek') {
      if (
        confirmationPolicyUZ == '' ||
        confirmationPolicyUZ == null ||
        confirmationPolicyUZ == undefined
      ) {
        errorTmp[0].confirmationPolicyUZ = t('Description Is Required')
        isValid = false
      }
      if (
        contractAmountCheckUZ == '' ||
        contractAmountCheckUZ == null ||
        contractAmountCheckUZ == undefined
      ) {
        errorTmp[0].contractAmountCheckUZ = t('Description Is Required')
        isValid = false
      }
      if (
        inspectionGuidelinesUZ == '' ||
        inspectionGuidelinesUZ == null ||
        inspectionGuidelinesUZ == undefined
      ) {
        errorTmp[0].inspectionGuidelinesUZ = t('Description Is Required')
        isValid = false
      }
    }

    setError(errorTmp)
    return isValid
  }
  const validate4 = () => {
    var isValid = true
    var errorTmp = [...error]

    if (primaryLanguage == 'English') {
      if (extrasEN == '' || extrasEN == null || extrasEN == undefined) {
        errorTmp[0].extrasEN = t('Description Is Required')
        isValid = false
      }
      if (texesAndFessEN == '' || texesAndFessEN == null || texesAndFessEN == undefined) {
        errorTmp[0].texesAndFessEN = t('Description Is Required')
        isValid = false
      }
    } else if (primaryLanguage == 'Russian') {
      if (extrasRU == '' || extrasRU == null || extrasRU == undefined) {
        errorTmp[0].extrasRU = t('Description Is Required')
        isValid = false
      }
      if (texesAndFessRU == '' || texesAndFessRU == null || texesAndFessRU == undefined) {
        errorTmp[0].texesAndFessRU = t('Description Is Required')
        isValid = false
      }
    } else if (primaryLanguage == 'Uzbek') {
      if (extrasUZ == '' || extrasUZ == null || extrasUZ == undefined) {
        errorTmp[0].extrasUZ = t('Description Is Required')
        isValid = false
      }
      if (texesAndFessUZ == '' || texesAndFessUZ == null || texesAndFessUZ == undefined) {
        errorTmp[0].texesAndFessUZ = t('Description Is Required')
        isValid = false
      }
    }

    setError(errorTmp)
    return isValid
  }
  const validate5 = () => {
    var isValid = true
    var errorTmp = [...error]

    if (primaryLanguage == 'English') {
      // if (modificationsEN == "" || modificationsEN == null || modificationsEN == undefined) {
      //     errorTmp[0].modificationsEN = t('Description Is Required');
      //     isValid = false;
      // }
      // if (noShowsEN == "" || noShowsEN == null || noShowsEN == undefined) {
      //     errorTmp[0].noShowsEN = t('Description Is Required');
      //     isValid = false;
      // }
      if (cancellationEN == '' || cancellationEN == null || cancellationEN == undefined) {
        errorTmp[0].cancellationEN = t('Description Is Required')
        isValid = false
      }
    } else if (primaryLanguage == 'Russian') {
      // if (modificationsRU == "" || modificationsRU == null || modificationsRU == undefined) {
      //     errorTmp[0].modificationsRU = t('Description Is Required');
      //     isValid = false;
      // }
      // if (noShowsRU == "" || noShowsRU == null || noShowsRU == undefined) {
      //     errorTmp[0].noShowsRU = t('Description Is Required');
      //     isValid = false;
      // }
      if (cancellationRU == '' || cancellationRU == null || cancellationRU == undefined) {
        errorTmp[0].cancellationRU = t('Description Is Required')
        isValid = false
      }
    } else if (primaryLanguage == 'Uzbek') {
      // if (modificationsUZ == "" || modificationsUZ == null || modificationsUZ == undefined) {
      //     errorTmp[0].modificationsUZ = t('Description Is Required');
      //     isValid = false;
      // }
      // if (noShowsUZ == "" || noShowsUZ == null || noShowsUZ == undefined) {
      //     errorTmp[0].noShowsUZ = t('Description Is Required');
      //     isValid = false;
      // }
      if (cancellationUZ == '' || cancellationUZ == null || cancellationUZ == undefined) {
        errorTmp[0].cancellationUZ = t('Description Is Required')
        isValid = false
      }
    }
    if (!isNonRefundable && !isFreeCancellation) {
      toasterrormsg(t('Please select a cancellation policy'))
      return
    }
    if (isFreeCancellation && !isValidFee) {
      toasterrormsg(t('Please Select days or percentage'))
      return
    }
    setError(errorTmp)
    return isValid
  }
  const validate6 = () => {
    var isValid = true
    var errorTmp = [...error]

    if (primaryLanguage == 'English') {
      if (
        accidentsAndBreakdownsEN == '' ||
        accidentsAndBreakdownsEN == null ||
        accidentsAndBreakdownsEN == undefined
      ) {
        errorTmp[0].accidentsAndBreakdownsEN = t('Description Is Required')
        isValid = false
      }
      if (
        roadsideAssistanceEN == '' ||
        roadsideAssistanceEN == null ||
        roadsideAssistanceEN == undefined
      ) {
        errorTmp[0].roadsideAssistanceEN = t('Description Is Required')
        isValid = false
      }
      if (lostKeysEN == '' || lostKeysEN == null || lostKeysEN == undefined) {
        errorTmp[0].lostKeysEN = t('Description Is Required')
        isValid = false
      }
      if (seatBeltsEN == '' || seatBeltsEN == null || seatBeltsEN == undefined) {
        errorTmp[0].seatBeltsEN = t('Description Is Required')
        isValid = false
      }
      if (noSmokingEN == '' || noSmokingEN == null || noSmokingEN == undefined) {
        errorTmp[0].noSmokingEN = t('Description Is Required')
        isValid = false
      }
      if (
        priceCalculationEN == '' ||
        priceCalculationEN == null ||
        priceCalculationEN == undefined
      ) {
        errorTmp[0].priceCalculationEN = t('Description Is Required')
        isValid = false
      }
      if (violationsEN == '' || violationsEN == null || violationsEN == undefined) {
        errorTmp[0].violationsEN = t('Description Is Required')
        isValid = false
      }
      if (
        travelRestrictionsEN == '' ||
        travelRestrictionsEN == null ||
        travelRestrictionsEN == undefined
      ) {
        errorTmp[0].travelRestrictionsEN = t('Description Is Required')
        isValid = false
      }
    } else if (primaryLanguage == 'Russian') {
      if (
        accidentsAndBreakdownsRU == '' ||
        accidentsAndBreakdownsRU == null ||
        accidentsAndBreakdownsRU == undefined
      ) {
        errorTmp[0].accidentsAndBreakdownsRU = t('Description Is Required')
        isValid = false
      }
      if (
        roadsideAssistanceRU == '' ||
        roadsideAssistanceRU == null ||
        roadsideAssistanceRU == undefined
      ) {
        errorTmp[0].roadsideAssistanceRU = t('Description Is Required')
        isValid = false
      }
      if (lostKeysRU == '' || lostKeysRU == null || lostKeysRU == undefined) {
        errorTmp[0].lostKeysRU = t('Description Is Required')
        isValid = false
      }
      if (seatBeltsRU == '' || seatBeltsRU == null || seatBeltsRU == undefined) {
        errorTmp[0].seatBeltsRU = t('Description Is Required')
        isValid = false
      }
      if (noSmokingRU == '' || noSmokingRU == null || noSmokingRU == undefined) {
        errorTmp[0].noSmokingRU = t('Description Is Required')
        isValid = false
      }
      if (
        priceCalculationRU == '' ||
        priceCalculationRU == null ||
        priceCalculationRU == undefined
      ) {
        errorTmp[0].priceCalculationRU = t('Description Is Required')
        isValid = false
      }
      if (violationsRU == '' || violationsRU == null || violationsRU == undefined) {
        errorTmp[0].violationsRU = t('Description Is Required')
        isValid = false
      }
      if (
        travelRestrictionsRU == '' ||
        travelRestrictionsRU == null ||
        travelRestrictionsRU == undefined
      ) {
        errorTmp[0].travelRestrictionsRU = t('Description Is Required')
        isValid = false
      }
    } else if (primaryLanguage == 'Uzbek') {
      if (
        accidentsAndBreakdownsUZ == '' ||
        accidentsAndBreakdownsUZ == null ||
        accidentsAndBreakdownsUZ == undefined
      ) {
        errorTmp[0].accidentsAndBreakdownsUZ = t('Description Is Required')
        isValid = false
      }
      if (
        roadsideAssistanceUZ == '' ||
        roadsideAssistanceUZ == null ||
        roadsideAssistanceUZ == undefined
      ) {
        errorTmp[0].roadsideAssistanceUZ = t('Description Is Required')
        isValid = false
      }
      if (lostKeysUZ == '' || lostKeysUZ == null || lostKeysUZ == undefined) {
        errorTmp[0].lostKeysUZ = t('Description Is Required')
        isValid = false
      }
      if (seatBeltsUZ == '' || seatBeltsUZ == null || seatBeltsUZ == undefined) {
        errorTmp[0].seatBeltsUZ = t('Description Is Required')
        isValid = false
      }
      if (noSmokingUZ == '' || noSmokingUZ == null || noSmokingUZ == undefined) {
        errorTmp[0].noSmokingUZ = t('Description Is Required')
        isValid = false
      }
      if (
        priceCalculationUZ == '' ||
        priceCalculationUZ == null ||
        priceCalculationUZ == undefined
      ) {
        errorTmp[0].priceCalculationUZ = t('Description Is Required')
        isValid = false
      }
      if (violationsUZ == '' || violationsUZ == null || violationsUZ == undefined) {
        errorTmp[0].violationsUZ = t('Description Is Required')
        isValid = false
      }
      if (
        travelRestrictionsUZ == '' ||
        travelRestrictionsUZ == null ||
        travelRestrictionsUZ == undefined
      ) {
        errorTmp[0].travelRestrictionsUZ = t('Description Is Required')
        isValid = false
      }
    }

    setError(errorTmp)
    return isValid
  }
  const validate7 = () => {
    var isValid = true
    if (showPolicy) {
      const newErrors = {} as any
      policies.forEach((policy: any, index: any) => {
        if (primaryLanguage == 'English') {
          if (!policy.en_title) {
            newErrors[index] = {...newErrors[index], titleEN: t('Policy Title Is Required')}
            isValid = false
          }
          if (!policy.en_description) {
            newErrors[index] = {...newErrors[index], descriptionEN: t('Description Is Required')}
            isValid = false
          }
        } else if (primaryLanguage == 'Russian') {
          if (!policy.ru_title) {
            newErrors[index] = {...newErrors[index], titleRU: t('Policy Title Is Required')}
            isValid = false
          }
          if (!policy.ru_description) {
            newErrors[index] = {...newErrors[index], descriptionRU: t('Description Is Required')}
            isValid = false
          }
        } else if (primaryLanguage == 'Uzbek') {
          if (!policy.uz_title) {
            newErrors[index] = {...newErrors[index], titleUZ: t('Policy Title Is Required')}
            isValid = false
          }
          if (!policy.uz_description) {
            newErrors[index] = {...newErrors[index], descriptionUZ: t('Description Is Required')}
            isValid = false
          }
        }
      })
      setErrors(newErrors)
    }
    return isValid
  }

  const nextToTab2 = () => {
    if (validate1()) {
      setTab('2')
    }
  }
  const nextToTab3 = () => {
    if (validate2()) {
      setTab('3')
    }
  }
  const nextToTab4 = () => {
    if (validate3()) {
      setTab('4')
    }
  }
  const nextToTab5 = () => {
    if (validate4()) {
      setTab('5')
    }
  }
  const nextToTab6 = () => {
    if (validate5()) {
      setTab('6')
    }
  }
  const nextToTab7 = () => {
    if (validate6()) {
      setTab('7')
    }
  }
  const isValidFee = fee.every((fees) => {
    return fees.day && fees.percentage
  })
  // add business details api call
  const AddCarRentalPolicies = async () => {
    if (validate7()) {
      setDisable(true)
      setLoading(true)
      var param: any = {
        carrentalId: String(editCarrentalId),
        mileagePolicyId: mileagePolicyId,
        en_mileagePolicy: mileagePolicyEN,
        ru_mileagePolicy: mileagePolicyRU,
        uz_mileagePolicy: mileagePolicyUZ,
        fuelPolicyId: fuelPolicyId,
        en_fuelPolicy: fuelPolicyEN,
        ru_fuelPolicy: fuelPolicyRU,
        uz_fuelPolicy: fuelPolicyUZ,
        ageRequirementId: ageRequirementId,
        en_ageRequirement: ageRequirementEN,
        ru_ageRequirement: ageRequirementRU,
        uz_ageRequirement: ageRequirementUZ,
        additionalDriversId: additionalDriversId,
        en_additionalDrivers: additionalDriversEN,
        ru_additionalDrivers: additionalDriversRU,
        uz_additionalDrivers: additionalDriversUZ,
        outisideBusinessHourId: outisideBusinessHourId,
        en_outisideBusinessHour: outsideOfBusinessHoursEN,
        ru_outisideBusinessHour: outsideOfBusinessHoursRU,
        uz_outisideBusinessHour: outsideOfBusinessHoursUZ,
        localFeesId: localFeesId,
        en_localFees: localFeesEN,
        ru_localFees: localFeesRU,
        uz_localFees: localFeesUZ,
        branchNoticeId: branchNoticeId,
        en_branchNotice: branchNoticeEN,
        ru_branchNotice: branchNoticeRU,
        uz_branchNotice: branchNoticeUZ,
        deposit: securityDepositAmount,
        aboutDepositsId: aboutDepositsId,
        en_aboutDeposits: aboutDepositsEN,
        ru_aboutDeposits: aboutDepositsRU,
        uz_aboutDeposits: aboutDepositsUZ,
        earlyPickUpId: earlyPickUpId,
        en_earlyPickUp: earlyPickUpEN,
        ru_earlyPickUp: earlyPickUpRU,
        uz_earlyPickUp: earlyPickUpUZ,
        latePickUpId: latePickUpId,
        en_latePickUp: latePickUpEN,
        ru_latePickUp: latePickUpRU,
        uz_latePickUp: latePickUpUZ,
        earlyDropOffId: earlyDropOffId,
        en_earlyDropOff: earlyDropOffEN,
        ru_earlyDropOff: earlyDropOffRU,
        uz_earlyDropOff: earlyDropOffUZ,
        lateDropOffId: lateDropOffId,
        en_lateDropOff: lateDropOffEN,
        ru_lateDropOff: lateDropOffRU,
        uz_lateDropOff: lateDropOffUZ,
        confirmationPolicyId: confirmationPolicyId,
        en_confirmationPolicy: confirmationPolicyEN,
        ru_confirmationPolicy: confirmationPolicyRU,
        uz_confirmationPolicy: confirmationPolicyUZ,
        contractAmountCheckId: contractAmountCheckId,
        en_contractAmountCheck: contractAmountCheckEN,
        ru_contractAmountCheck: contractAmountCheckRU,
        uz_contractAmountCheck: contractAmountCheckUZ,
        inspectionGuidelinesId: inspectionGuidelinesId,
        en_inspectionGuidelines: inspectionGuidelinesEN,
        ru_inspectionGuidelines: inspectionGuidelinesRU,
        uz_inspectionGuidelines: inspectionGuidelinesUZ,
        extrasId: extrasId,
        en_extras: extrasEN,
        ru_extras: extrasRU,
        uz_extras: extrasUZ,
        texesAndFeesId: texesAndFeesId,
        en_texesAndFees: texesAndFessEN,
        ru_texesAndFees: texesAndFessRU,
        uz_texesAndFees: texesAndFessUZ,
        // modifictionsId: modifictionsId,
        // en_modifictions: modificationsEN,
        // ru_modifictions: modificationsRU,
        // uz_modifictions: modificationsUZ,
        // noShowsId: noShowsId,
        // en_noShows: noShowsEN,
        // ru_noShows: noShowsRU,
        // uz_noShows: noShowsUZ,
        accidentAndBreakDownsId: accidentAndBreakDownsId,
        en_accidentAndBreakDowns: accidentsAndBreakdownsEN,
        ru_accidentAndBreakDowns: accidentsAndBreakdownsRU,
        uz_accidentAndBreakDowns: accidentsAndBreakdownsUZ,
        roadsideAssitanceId: roadsideAssitanceId,
        en_roadsideAssitance: roadsideAssistanceEN,
        ru_roadsideAssitance: roadsideAssistanceRU,
        uz_roadsideAssitance: roadsideAssistanceUZ,
        lostKeysId: lostKeysId,
        en_lostKeys: lostKeysEN,
        ru_lostKeys: lostKeysRU,
        uz_lostKeys: lostKeysUZ,
        seatBeltsId: seatBeltsId,
        en_seatBelts: seatBeltsEN,
        ru_seatBelts: seatBeltsRU,
        uz_seatBelts: seatBeltsUZ,
        noSmokingId: noSmokingId,
        en_noSmoking: noSmokingEN,
        ru_noSmoking: noSmokingRU,
        uz_noSmoking: noSmokingUZ,
        priceCalculationId: priceCalculationId,
        en_priceCalculation: priceCalculationEN,
        ru_priceCalculation: priceCalculationRU,
        uz_priceCalculation: priceCalculationUZ,
        violationsId: violationsId,
        en_violations: violationsEN,
        ru_violations: violationsRU,
        uz_violations: violationsUZ,
        travelRestricationsId: travelRestricationsId,
        en_travelRestrications: travelRestrictionsEN,
        ru_travelRestrications: travelRestrictionsRU,
        uz_travelRestrications: travelRestrictionsUZ,
        en_cancellation: cancellationEN,
        ru_cancellation: cancellationRU,
        uz_cancellation: cancellationUZ,
        isNonRefundable: isNonRefundable ? '1' : '0',
      }
      if (showPolicy) {
        param['customPolicy'] = policies
      }
      if (cancellationId != '') {
        param['cancellationId'] = String(cancellationId)
      }
      if (isFreeCancellation) {
        param['cancellationDay'] = cancellationDay
      }
      var response: any = await fetchData('public/addCarRentalPolicy', param)
      if (response.status == '200') {
        toastsuccessmsg(t('Policy Saved Successfully!'))
        const state = {
          carrentalId: editCarrentalId,
        }
        setTimeout(() => {
          navigate('../addcarrentalfinance/', {state})
          setDisable(false)
          setLoading(false)
        }, 1500)
      } else {
        toasterrormsg(response.message)
        setDisable(false)
        setLoading(false)
      }
    }
  }
  const carRentalDetailsApiCall = async () => {
    var param: any = {
      carrentalId: String(editCarrentalId),
    }
    var response: any = await fetchData('public/carRentalDetail', param)
    if (response.status == '200') {
      setCarRentalDetails(response.data)
      var data = response.data[0]
      const policy = data.policyDetail
      if (policy.mileagePolicyId) {
        setMileagePolicyId(policy.mileagePolicyId + '')
      }
      setMileagePolicyEN(policy.en_mileagePolicy)
      setMileagePolicyRU(policy.ru_mileagePolicy)
      setMileagePolicyUZ(policy.uz_mileagePolicy)
      if (policy.fuelPolicyId) {
        setFuelPolicyId(policy.fuelPolicyId + '')
      }
      setFuelPolicyEN(policy.en_fuelPolicy)
      setFuelPolicyRU(policy.ru_fuelPolicy)
      setFuelPolicyUZ(policy.uz_fuelPolicy)
      if (policy.ageRequirementId) {
        setAgeRequirementId(policy.ageRequirementId + '')
      }
      setAgeRequirementEN(policy.en_ageRequirement)
      setAgeRequirementRU(policy.ru_ageRequirement)
      setAgeRequirementUZ(policy.uz_ageRequirement)
      if (policy.additionalDriversId) {
        setAdditionalDriversId(policy.additionalDriversId + '')
      }
      setAdditionalDriversEN(policy.en_additionalDrivers)
      setAdditionalDriversRU(policy.ru_additionalDrivers)
      setAdditionalDriversUZ(policy.uz_additionalDrivers)
      if (policy.outisideBusinessHourId) {
        setOutisideBusinessHourId(policy.outisideBusinessHourId + '')
      }
      setOutsideOfBusinessHoursEN(policy.en_outisideBusinessHour)
      setOutsideOfBusinessHoursRU(policy.ru_outisideBusinessHour)
      setOutsideOfBusinessHoursUZ(policy.uz_outisideBusinessHour)
      if (policy.localFeesId) {
        setLocalFeesId(policy.localFeesId + '')
      }
      setLocalFeesEN(policy.en_localFees)
      setLocalFeesRU(policy.ru_localFees)
      setLocalFeesUZ(policy.uz_localFees)
      if (policy.branchNoticeId) {
        setBranchNoticeId(policy.branchNoticeId + '')
      }
      setBranchNoticeEN(policy.en_branchNotice)
      setBranchNoticeRU(policy.ru_branchNotice)
      setBranchNoticeUZ(policy.uz_branchNotice)
      setSecurityDepositAmount(data.deposit + '')
      if (policy.aboutDepositsId) {
        setAboutDepositsId(policy.aboutDepositsId + '')
      }
      setAboutDepositsEN(policy.en_aboutDeposits)
      setAboutDepositsRU(policy.ru_aboutDeposits)
      setAboutDepositsUZ(policy.uz_aboutDeposits)
      if (policy.earlyPickUpId) {
        setEarlyPickUpId(policy.earlyPickUpId + '')
      }
      setEarlyPickUpEN(policy.en_earlyPickUp)
      setEarlyPickUpRU(policy.ru_earlyPickUp)
      setEarlyPickUpUZ(policy.uz_earlyPickUp)
      if (policy.latePickUpId) {
        setLatePickUpId(policy.latePickUpId + '')
      }
      setLatePickUpEN(policy.en_latePickUp)
      setLatePickUpRU(policy.ru_latePickUp)
      setLatePickUpUZ(policy.uz_latePickUp)
      if (policy.earlyDropOffId) {
        setEarlyDropOffId(policy.earlyDropOffId + '')
      }
      setEarlyDropOffEN(policy.en_earlyDropOff)
      setEarlyDropOffRU(policy.ru_earlyDropOff)
      setEarlyDropOffUZ(policy.uz_earlyDropOff)
      if (policy.lateDropOffId) {
        setLateDropOffId(policy.lateDropOffId + '')
      }
      setLateDropOffEN(policy.en_lateDropOff)
      setLateDropOffRU(policy.ru_lateDropOff)
      setLateDropOffUZ(policy.uz_lateDropOff)
      if (policy.confirmationPolicyId) {
        setConfirmationPolicyId(policy.confirmationPolicyId + '')
      }
      setConfirmationPolicyEN(policy.en_confirmationPolicy)
      setConfirmationPolicyRU(policy.ru_confirmationPolicy)
      setConfirmationPolicyUZ(policy.uz_confirmationPolicy)
      if (policy.contractAmountCheckId) {
        setContractAmountCheckId(policy.contractAmountCheckId + '')
      }
      setContractAmountCheckEN(policy.en_contractAmountCheck)
      setContractAmountCheckRU(policy.ru_contractAmountCheck)
      setContractAmountCheckUZ(policy.uz_contractAmountCheck)
      if (policy.inspectionGuidelinesId) {
        setInspectionGuidelinesId(policy.inspectionGuidelinesId + '')
      }
      setInspectionGuidelinesEN(policy.en_inspectionGuidelines)
      setInspectionGuidelinesRU(policy.ru_inspectionGuidelines)
      setInspectionGuidelinesUZ(policy.uz_inspectionGuidelines)
      if (policy.extrasId) {
        setExtrasId(policy.extrasId + '')
      }
      setExtrasEN(policy.en_extras)
      setExtrasRU(policy.ru_extras)
      setExtrasUZ(policy.uz_extras)
      if (policy.texesAndFeesId) {
        setTexesAndFeesId(policy.texesAndFeesId + '')
      }
      setTexesAndFessEN(policy.en_texesAndFees)
      setTexesAndFessRU(policy.ru_texesAndFees)
      setTexesAndFessUZ(policy.uz_texesAndFees)
      // if (policy.modifictionsId) {
      //     setModifictionsId(policy.modifictionsId + '')
      // }
      // setModificationsEN(policy.en_modifictions)
      // setModificationsRU(policy.ru_modifictions)
      // setModificationsUZ(policy.uz_modifictions)
      // if (policy.noShowsId) {
      //     setNoShowsId(policy.noShowsId + '')
      // }
      // setNoShowsEN(policy.en_noShows)
      // setNoShowsRU(policy.ru_noShows)
      // setNoShowsUZ(policy.uz_noShows)
      if (policy.cancellationId) {
        setCancellationId(policy.cancellationId + '')
      }
      const nonRefundable = data.isNonRefundable == 1 || data.isNonRefundable === true
      setIsNonRefundable(nonRefundable)
      setIsFreeCancellation(!nonRefundable && data.cancellationDay.length > 0)
      if (data.cancellationDay.length > 0) {
        const apiTab = data.cancellationDay[0]['cancellationDay']
        setPolicyTab(apiTab)
        setFee(data.cancellationDay[0]['fee'])
        setCancellationDay(data.cancellationDay)
        setApiData((prev: any) => ({
          ...prev,
          [apiTab]: {
            fee: data.cancellationDay[0]['fee'],
            cancellationDay: data.cancellationDay,
          },
        }))
        // Mark this tab as API-provided
        setApiTabs(new Set([...apiTabs, apiTab]))
      }
      setCancellationEN(policy.en_cancellation)
      setCancellationRU(policy.ru_cancellation)
      setCancellationUZ(policy.uz_cancellation)
      if (policy.accidentAndBreakDownsId) {
        setAccidentAndBreakDownsId(policy.accidentAndBreakDownsId + '')
      }
      setAccidentsAndBreakdownsEN(policy.en_accidentAndBreakDowns)
      setAccidentsAndBreakdownsRU(policy.ru_accidentAndBreakDowns)
      setAccidentsAndBreakdownsUZ(policy.uz_accidentAndBreakDowns)
      if (policy.roadsideAssitanceId) {
        setRoadsideAssitanceId(policy.roadsideAssitanceId + '')
      }
      setRoadsideAssistanceEN(policy.en_roadsideAssitance)
      setRoadsideAssistanceRU(policy.ru_roadsideAssitance)
      setRoadsideAssistanceUZ(policy.uz_roadsideAssitance)
      if (policy.lostKeysId) {
        setLostKeysId(policy.lostKeysId + '')
      }
      setLostKeysEN(policy.en_lostKeys)
      setLostKeysRU(policy.ru_lostKeys)
      setLostKeysUZ(policy.uz_lostKeys)
      if (policy.seatBeltsId) {
        setSeatBeltsId(policy.seatBeltsId + '')
      }
      setSeatBeltsEN(policy.en_seatBelts)
      setSeatBeltsRU(policy.ru_seatBelts)
      setSeatBeltsUZ(policy.uz_seatBelts)
      if (policy.noSmokingId) {
        setNoSmokingId(policy.noSmokingId + '')
      }
      setNoSmokingEN(policy.en_noSmoking)
      setNoSmokingRU(policy.ru_noSmoking)
      setNoSmokingUZ(policy.uz_noSmoking)
      if (policy.priceCalculationId) {
        setPriceCalculationId(policy.priceCalculationId + '')
      }
      setPriceCalculationEN(policy.en_priceCalculation)
      setPriceCalculationRU(policy.ru_priceCalculation)
      setPriceCalculationUZ(policy.uz_priceCalculation)
      if (policy.violationsId) {
        setViolationsId(policy.violationsId + '')
      }
      setViolationsEN(policy.en_violations)
      setViolationsRU(policy.ru_violations)
      setViolationsUZ(policy.uz_violations)
      if (policy.travelRestricationsId) {
        setTravelRestricationsId(policy.travelRestricationsId + '')
      }
      setTravelRestrictionsEN(policy.en_travelRestrications)
      setTravelRestrictionsRU(policy.ru_travelRestrications)
      setTravelRestrictionsUZ(policy.uz_travelRestrications)
      if (policy.customPolicy.length != 0) {
        setShowPolicy(true)
        setPolicies(policy.customPolicy)
      }
    } else {
      toasterrormsg(response.message)
    }
  }
  useEffect(() => {
    if (editCarrentalId != '') {
      carRentalDetailsApiCall()
    }
  }, [])

  return (
    <>
      <ToastContainer />
      <PageTitle breadcrumbs={[]}>
        {editCarrentalId != '' ? t('Edit Policy') : t('Add Policy')}
      </PageTitle>
      <AddCarRentalHeader carrentalId={editCarrentalId} />
      <div className='d-flex flex-column flex-column-fluid'>
        {/* <!--begin::Content--> */}
        <div id='kt_app_content' className='app-content flex-column-fluid'>
          {/* <!--begin::Form--> */}
          <div className='form d-flex flex-column flex-lg-row'>
            {/* <!--begin::Main column--> */}
            <div className='d-flex flex-column flex-row-fluid gap-7 gap-lg-10'>
              {/* <!--begin::Tab content--> */}
              <div className='tab-content'>
                {/* <!--begin::Tab pane--> */}
                <div
                  className='tab-pane fade show active'
                  id='kt_ecommerce_add_product_general'
                  role='tab-panel'
                >
                  <div className='d-flex flex-column'>
                    {/* <!--begin::General options--> */}
                    <div className='card card-flush py-4'>
                      {/* <!--begin::Card header--> */}
                      <div className='card-header d-flex'>
                        {/* <!--begin::Card title--> */}
                        <div className='card-title'>
                          <h2>{t('Policies')}</h2>
                        </div>
                        {/* <!--end::Card title--> */}
                        <div className='d-flex align-items-center w-200px w-sm-300px flex-column'>
                          {carRentalDetails.length != 0 ? (
                            <>
                              {carRentalDetails.map((completedSteps: any, index: any) => {
                                var percentage = 0
                                if (completedSteps['completedSteps']['basicInfo']) {
                                  percentage = 10
                                }
                                if (completedSteps['completedSteps']['location']) {
                                  percentage = 20
                                }
                                if (completedSteps['completedSteps']['carRentalInfo']) {
                                  percentage = 40
                                }
                                if (completedSteps['completedSteps']['photos']) {
                                  percentage = 50
                                }
                                if (completedSteps['completedSteps']['insurance']) {
                                  percentage = 60
                                }
                                if (completedSteps['completedSteps']['documentsRequired']) {
                                  percentage = 70
                                }
                                if (completedSteps['completedSteps']['availability']) {
                                  percentage = 70
                                }
                                if (completedSteps['completedSteps']['pickupDropoffInfo']) {
                                  percentage = 80
                                }
                                if (completedSteps['completedSteps']['policies']) {
                                  percentage = 90
                                }
                                if (completedSteps['completedSteps']['financeAndLegal']) {
                                  percentage = 100
                                }
                                return (
                                  <React.Fragment key={index}>
                                    <div className='d-flex justify-content-between w-100 mt-auto'>
                                      <span className='fw-bold fs-6'>{t('Completion')}</span>
                                      <span className='fw-bolder fs-6'>{percentage}%</span>
                                    </div>
                                    <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                      <div
                                        className='bg-success rounded h-5px'
                                        role='progressbar'
                                        style={{width: `${percentage}%`}}
                                      ></div>
                                    </div>
                                  </React.Fragment>
                                )
                              })}
                            </>
                          ) : (
                            <>
                              <div className='d-flex justify-content-between w-100 mt-auto'>
                                <span className='fw-bold fs-6'>{t('Completion')}</span>
                                <span className='fw-bolder fs-6'>0%</span>
                              </div>
                              <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                <div
                                  className='bg-success rounded h-5px'
                                  role='progressbar'
                                  style={{width: '0%'}}
                                ></div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                      {/* <!--end::Card header--> */}
                      <div className='card card-custom my-5'>
                        <div className='card-header card-header-stretch overflow-auto'>
                          <ul
                            className='nav nav-stretch nav-line-tabs fw-semibold border-transparent flex-nowrap'
                            role='tablist'
                          >
                            <li className='nav-item'>
                              <a
                                className={clsx(
                                  `nav-link cursor-pointer text-uppercase text-center`,
                                  {active: tab === '1'}
                                )}
                                onClick={() => setTab('1')}
                                role='tab'
                              >
                                {t('About Fees & Charges')}
                              </a>
                            </li>
                            <li className='nav-item'>
                              <a
                                className={clsx(
                                  `nav-link cursor-pointer text-uppercase text-center`,
                                  {active: tab === '2'}
                                )}
                                onClick={nextToTab2}
                                role='tab'
                              >
                                {t('Early/Late Pick Up & Drop Off')}
                              </a>
                            </li>
                            <li className='nav-item'>
                              <a
                                className={clsx(
                                  `nav-link cursor-pointer text-uppercase text-center`,
                                  {active: tab === '3'}
                                )}
                                onClick={nextToTab3}
                                role='tab'
                              >
                                {t('Pick Up Information')}
                              </a>
                            </li>
                            <li className='nav-item'>
                              <a
                                className={clsx(
                                  `nav-link cursor-pointer text-uppercase text-center`,
                                  {active: tab === '4'}
                                )}
                                onClick={nextToTab4}
                                role='tab'
                              >
                                {t('Extras')}
                              </a>
                            </li>
                            <li className='nav-item'>
                              <a
                                className={clsx(
                                  `nav-link cursor-pointer text-uppercase text-center`,
                                  {active: tab === '5'}
                                )}
                                onClick={nextToTab5}
                                role='tab'
                              >
                                {t('Cancellation')}
                              </a>
                            </li>
                            <li className='nav-item'>
                              <a
                                className={clsx(
                                  `nav-link cursor-pointer text-uppercase text-center`,
                                  {active: tab === '6'}
                                )}
                                onClick={nextToTab6}
                                role='tab'
                              >
                                {t('Information About The Car Supplier')}
                              </a>
                            </li>
                            <li className='nav-item'>
                              <a
                                className={clsx(
                                  `nav-link cursor-pointer text-uppercase text-center`,
                                  {active: tab === '7'}
                                )}
                                onClick={nextToTab7}
                                role='tab'
                              >
                                {t('Custom Policy Add')}
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      {/* <!--begin::Card body--> */}
                      <div className='card-body'>
                        <div className='tab-content'>
                          <div className={clsx('tab-pane', {active: tab === '1'})}>
                            {primaryLanguage == 'English' && (
                              <>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Mileage Policy (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='mileagePolicyEN'
                                      className='form-control mb-2'
                                      placeholder={t('Mileage Policy')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setMileagePolicyEN(e.target.value)
                                        removeError('mileagePolicyEN')
                                      }}
                                      value={mileagePolicyEN}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].mileagePolicyEN}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Mileage Policy (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='mileagePolicyRU'
                                      className='form-control mb-2'
                                      placeholder={t('Mileage Policy')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setMileagePolicyRU(e.target.value)
                                      }}
                                      value={mileagePolicyRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Mileage Policy (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='mileagePolicyUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Mileage Policy')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setMileagePolicyUZ(e.target.value)
                                      }}
                                      value={mileagePolicyUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Fuel Policy (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='fuelPolicyEN'
                                      className='form-control mb-2'
                                      placeholder={t('Fuel Policy')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setFuelPolicyEN(e.target.value)
                                        removeError('fuelPolicyEN')
                                      }}
                                      value={fuelPolicyEN}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].fuelPolicyEN}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Fuel Policy (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='fuelPolicyRU'
                                      className='form-control mb-2'
                                      placeholder={t('Fuel Policy')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setFuelPolicyRU(e.target.value)
                                      }}
                                      value={fuelPolicyRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Fuel Policy (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='fuelPolicyUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Fuel Policy')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setFuelPolicyUZ(e.target.value)
                                      }}
                                      value={fuelPolicyUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Age Requirement (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='ageRequirementEN'
                                      className='form-control mb-2'
                                      placeholder={t('Age Requirement')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setAgeRequirementEN(e.target.value)
                                        removeError('ageRequirementEN')
                                      }}
                                      value={ageRequirementEN}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].ageRequirementEN}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Age Requirement (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='ageRequirementRU'
                                      className='form-control mb-2'
                                      placeholder={t('Age Requirement')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setAgeRequirementRU(e.target.value)
                                      }}
                                      value={ageRequirementRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Age Requirement (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='ageRequirementUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Age Requirement')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setAgeRequirementUZ(e.target.value)
                                      }}
                                      value={ageRequirementUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Additional Drivers (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='additionalDriversEN'
                                      className='form-control mb-2'
                                      placeholder={t('Additional Drivers')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setAdditionalDriversEN(e.target.value)
                                        removeError('additionalDriversEN')
                                      }}
                                      value={additionalDriversEN}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].additionalDriversEN}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Additional Drivers (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='additionalDriversRU'
                                      className='form-control mb-2'
                                      placeholder={t('Additional Drivers')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setAdditionalDriversRU(e.target.value)
                                      }}
                                      value={additionalDriversRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Additional Drivers (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='additionalDriversUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Additional Drivers')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setAdditionalDriversUZ(e.target.value)
                                      }}
                                      value={additionalDriversUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Outside Of Business Hours (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='outsideOfBusinessHoursEN'
                                      className='form-control mb-2'
                                      placeholder={t('Outside Of Business Hours')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setOutsideOfBusinessHoursEN(e.target.value)
                                        removeError('outsideOfBusinessHoursEN')
                                      }}
                                      value={outsideOfBusinessHoursEN}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].outsideOfBusinessHoursEN}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Outside Of Business Hours (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='outsideOfBusinessHoursRU'
                                      className='form-control mb-2'
                                      placeholder={t('Outside Of Business Hours')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setOutsideOfBusinessHoursRU(e.target.value)
                                      }}
                                      value={outsideOfBusinessHoursRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Outside Of Business Hours (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='outsideOfBusinessHoursUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Outside Of Business Hours')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setOutsideOfBusinessHoursUZ(e.target.value)
                                      }}
                                      value={outsideOfBusinessHoursUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Local Fees (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='localFeesEN'
                                      className='form-control mb-2'
                                      placeholder={t('Local Fees')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setLocalFeesEN(e.target.value)
                                        removeError('localFeesEN')
                                      }}
                                      value={localFeesEN}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].localFeesEN}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Local Fees (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='localFeesRU'
                                      className='form-control mb-2'
                                      placeholder={t('Local Fees')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setLocalFeesRU(e.target.value)
                                      }}
                                      value={localFeesRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Local Fees (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='localFeesUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Local Fees')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setLocalFeesUZ(e.target.value)
                                      }}
                                      value={localFeesUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Branch Notice (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='branchNoticeEN'
                                      className='form-control mb-2'
                                      placeholder={t('Branch Notice')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setBranchNoticeEN(e.target.value)
                                        removeError('branchNoticeEN')
                                      }}
                                      value={branchNoticeEN}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].branchNoticeEN}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Branch Notice (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='branchNoticeRU'
                                      className='form-control mb-2'
                                      placeholder={t('Branch Notice')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setBranchNoticeRU(e.target.value)
                                      }}
                                      value={branchNoticeRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Branch Notice (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='branchNoticeUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Branch Notice')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setBranchNoticeUZ(e.target.value)
                                      }}
                                      value={branchNoticeUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('About Deposits (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='aboutDepositsEN'
                                      className='form-control mb-2'
                                      placeholder={t('About Deposits')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setAboutDepositsEN(e.target.value)
                                        removeError('aboutDepositsEN')
                                      }}
                                      value={aboutDepositsEN}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].aboutDepositsEN}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('About Deposits (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='aboutDepositsRU'
                                      className='form-control mb-2'
                                      placeholder={t('About Deposits')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setAboutDepositsRU(e.target.value)
                                      }}
                                      value={aboutDepositsRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('About Deposits (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='aboutDepositsUZ'
                                      className='form-control mb-2'
                                      placeholder={t('About Deposits')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setAboutDepositsUZ(e.target.value)
                                      }}
                                      value={aboutDepositsUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                              </>
                            )}
                            {primaryLanguage == 'Russian' && (
                              <>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Mileage Policy (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='mileagePolicyRU'
                                      className='form-control mb-2'
                                      placeholder={t('Mileage Policy')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setMileagePolicyRU(e.target.value)
                                        removeError('mileagePolicyRU')
                                      }}
                                      value={mileagePolicyRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                    <div className='text-danger fw-bold'>
                                      {error[0].mileagePolicyRU}
                                    </div>
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Mileage Policy (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='mileagePolicyEN'
                                      className='form-control mb-2'
                                      placeholder={t('Mileage Policy')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setMileagePolicyEN(e.target.value)
                                      }}
                                      value={mileagePolicyEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Mileage Policy (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='mileagePolicyUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Mileage Policy')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setMileagePolicyUZ(e.target.value)
                                      }}
                                      value={mileagePolicyUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Fuel Policy (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='fuelPolicyRU'
                                      className='form-control mb-2'
                                      placeholder={t('Fuel Policy')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setFuelPolicyRU(e.target.value)
                                        removeError('fuelPolicyRU')
                                      }}
                                      value={fuelPolicyRU}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].fuelPolicyRU}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Fuel Policy (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='fuelPolicyEN'
                                      className='form-control mb-2'
                                      placeholder={t('Fuel Policy')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setFuelPolicyEN(e.target.value)
                                      }}
                                      value={fuelPolicyEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Fuel Policy (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='fuelPolicyUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Fuel Policy')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setFuelPolicyUZ(e.target.value)
                                      }}
                                      value={fuelPolicyUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Age Requirement (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='ageRequirementRU'
                                      className='form-control mb-2'
                                      placeholder={t('Age Requirement')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setAgeRequirementRU(e.target.value)
                                        removeError('ageRequirementRU')
                                      }}
                                      value={ageRequirementRU}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].ageRequirementRU}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Age Requirement (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='ageRequirementEN'
                                      className='form-control mb-2'
                                      placeholder={t('Age Requirement')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setAgeRequirementEN(e.target.value)
                                      }}
                                      value={ageRequirementEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Age Requirement (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='ageRequirementUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Age Requirement')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setAgeRequirementUZ(e.target.value)
                                      }}
                                      value={ageRequirementUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Additional Drivers (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='additionalDriversRU'
                                      className='form-control mb-2'
                                      placeholder={t('Additional Drivers')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setAdditionalDriversRU(e.target.value)
                                        removeError('additionalDriversRU')
                                      }}
                                      value={additionalDriversRU}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].additionalDriversRU}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Additional Drivers (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='additionalDriversEN'
                                      className='form-control mb-2'
                                      placeholder={t('Additional Drivers')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setAdditionalDriversEN(e.target.value)
                                      }}
                                      value={additionalDriversEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Additional Drivers (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='additionalDriversUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Additional Drivers')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setAdditionalDriversUZ(e.target.value)
                                      }}
                                      value={additionalDriversUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Outside Of Business Hours (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='outsideOfBusinessHoursRU'
                                      className='form-control mb-2'
                                      placeholder={t('Outside Of Business Hours')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setOutsideOfBusinessHoursRU(e.target.value)
                                        removeError('outsideOfBusinessHoursRU')
                                      }}
                                      value={outsideOfBusinessHoursRU}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].outsideOfBusinessHoursRU}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Outside Of Business Hours (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='outsideOfBusinessHoursEN'
                                      className='form-control mb-2'
                                      placeholder={t('Outside Of Business Hours')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setOutsideOfBusinessHoursEN(e.target.value)
                                      }}
                                      value={outsideOfBusinessHoursEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Outside Of Business Hours (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='outsideOfBusinessHoursUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Outside Of Business Hours')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setOutsideOfBusinessHoursUZ(e.target.value)
                                      }}
                                      value={outsideOfBusinessHoursUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Local Fees (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='localFeesRU'
                                      className='form-control mb-2'
                                      placeholder={t('Local Fees')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setLocalFeesRU(e.target.value)
                                        removeError('localFeesRU')
                                      }}
                                      value={localFeesRU}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].localFeesRU}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Local Fees (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='localFeesEN'
                                      className='form-control mb-2'
                                      placeholder={t('Local Fees')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setLocalFeesEN(e.target.value)
                                      }}
                                      value={localFeesEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Local Fees (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='localFeesUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Local Fees')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setLocalFeesUZ(e.target.value)
                                      }}
                                      value={localFeesUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Branch Notice (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='branchNoticeRU'
                                      className='form-control mb-2'
                                      placeholder={t('Branch Notice')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setBranchNoticeRU(e.target.value)
                                        removeError('branchNoticeRU')
                                      }}
                                      value={branchNoticeRU}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].branchNoticeRU}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Branch Notice (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='branchNoticeEN'
                                      className='form-control mb-2'
                                      placeholder={t('Branch Notice')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setBranchNoticeEN(e.target.value)
                                      }}
                                      value={branchNoticeEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Branch Notice (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='branchNoticeUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Branch Notice')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setBranchNoticeUZ(e.target.value)
                                      }}
                                      value={branchNoticeUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('About Deposits (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='aboutDepositsRU'
                                      className='form-control mb-2'
                                      placeholder={t('About Deposits')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setAboutDepositsRU(e.target.value)
                                        removeError('aboutDepositsRU')
                                      }}
                                      value={aboutDepositsRU}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].aboutDepositsRU}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('About Deposits (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='aboutDepositsEN'
                                      className='form-control mb-2'
                                      placeholder={t('About Deposits')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setAboutDepositsEN(e.target.value)
                                      }}
                                      value={aboutDepositsEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('About Deposits (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='aboutDepositsUZ'
                                      className='form-control mb-2'
                                      placeholder={t('About Deposits')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setAboutDepositsUZ(e.target.value)
                                      }}
                                      value={aboutDepositsUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                              </>
                            )}
                            {primaryLanguage == 'Uzbek' && (
                              <>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Mileage Policy (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='mileagePolicyUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Mileage Policy')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setMileagePolicyUZ(e.target.value)
                                        removeError('mileagePolicyUZ')
                                      }}
                                      value={mileagePolicyUZ}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].mileagePolicyUZ}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Mileage Policy (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='mileagePolicyRU'
                                      className='form-control mb-2'
                                      placeholder={t('Mileage Policy')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setMileagePolicyRU(e.target.value)
                                      }}
                                      value={mileagePolicyRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Mileage Policy (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='mileagePolicyEN'
                                      className='form-control mb-2'
                                      placeholder={t('Mileage Policy')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setMileagePolicyEN(e.target.value)
                                      }}
                                      value={mileagePolicyEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Fuel Policy (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='fuelPolicyUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Fuel Policy')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setFuelPolicyUZ(e.target.value)
                                        removeError('fuelPolicyUZ')
                                      }}
                                      value={fuelPolicyUZ}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].fuelPolicyUZ}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Fuel Policy (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='fuelPolicyRU'
                                      className='form-control mb-2'
                                      placeholder={t('Fuel Policy')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setFuelPolicyRU(e.target.value)
                                      }}
                                      value={fuelPolicyRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Fuel Policy (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='fuelPolicyEN'
                                      className='form-control mb-2'
                                      placeholder={t('Fuel Policy')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setFuelPolicyEN(e.target.value)
                                      }}
                                      value={fuelPolicyEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Age Requirement (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='ageRequirementUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Age Requirement')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setAgeRequirementUZ(e.target.value)
                                        removeError('ageRequirementUZ')
                                      }}
                                      value={ageRequirementUZ}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].ageRequirementUZ}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Age Requirement (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='ageRequirementRU'
                                      className='form-control mb-2'
                                      placeholder={t('Age Requirement')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setAgeRequirementRU(e.target.value)
                                      }}
                                      value={ageRequirementRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Age Requirement (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='ageRequirementEN'
                                      className='form-control mb-2'
                                      placeholder={t('Age Requirement')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setAgeRequirementEN(e.target.value)
                                      }}
                                      value={ageRequirementEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Additional Drivers (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='additionalDriversUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Additional Drivers')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setAdditionalDriversUZ(e.target.value)
                                        removeError('additionalDriversUZ')
                                      }}
                                      value={additionalDriversUZ}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].additionalDriversUZ}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Additional Drivers (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='additionalDriversRU'
                                      className='form-control mb-2'
                                      placeholder={t('Additional Drivers')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setAdditionalDriversRU(e.target.value)
                                      }}
                                      value={additionalDriversRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Additional Drivers (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='additionalDriversEN'
                                      className='form-control mb-2'
                                      placeholder={t('Additional Drivers')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setAdditionalDriversEN(e.target.value)
                                      }}
                                      value={additionalDriversEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Outside Of Business Hours (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='outsideOfBusinessHoursUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Outside Of Business Hours')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setOutsideOfBusinessHoursUZ(e.target.value)
                                        removeError('outsideOfBusinessHoursUZ')
                                      }}
                                      value={outsideOfBusinessHoursUZ}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].outsideOfBusinessHoursUZ}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Outside Of Business Hours (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='outsideOfBusinessHoursRU'
                                      className='form-control mb-2'
                                      placeholder={t('Outside Of Business Hours')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setOutsideOfBusinessHoursRU(e.target.value)
                                      }}
                                      value={outsideOfBusinessHoursRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Outside Of Business Hours (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='outsideOfBusinessHoursEN'
                                      className='form-control mb-2'
                                      placeholder={t('Outside Of Business Hours')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setOutsideOfBusinessHoursEN(e.target.value)
                                      }}
                                      value={outsideOfBusinessHoursEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Local Fees (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='localFeesUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Local Fees')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setLocalFeesUZ(e.target.value)
                                        removeError('localFeesUZ')
                                      }}
                                      value={localFeesUZ}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].localFeesUZ}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Local Fees (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='localFeesRU'
                                      className='form-control mb-2'
                                      placeholder={t('Local Fees')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setLocalFeesRU(e.target.value)
                                      }}
                                      value={localFeesRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Local Fees (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='localFeesEN'
                                      className='form-control mb-2'
                                      placeholder={t('Local Fees')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setLocalFeesEN(e.target.value)
                                      }}
                                      value={localFeesEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Branch Notice (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='branchNoticeUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Branch Notice')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setBranchNoticeUZ(e.target.value)
                                        removeError('branchNoticeUZ')
                                      }}
                                      value={branchNoticeUZ}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].branchNoticeUZ}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Branch Notice (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='branchNoticeEN'
                                      className='form-control mb-2'
                                      placeholder={t('Branch Notice')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setBranchNoticeEN(e.target.value)
                                      }}
                                      value={branchNoticeEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Branch Notice (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='branchNoticeRU'
                                      className='form-control mb-2'
                                      placeholder={t('Branch Notice')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setBranchNoticeRU(e.target.value)
                                      }}
                                      value={branchNoticeRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('About Deposits (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='aboutDepositsUZ'
                                      className='form-control mb-2'
                                      placeholder={t('About Deposits')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setAboutDepositsUZ(e.target.value)
                                        removeError('aboutDepositsUZ')
                                      }}
                                      value={aboutDepositsUZ}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].aboutDepositsUZ}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('About Deposits (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='aboutDepositsRU'
                                      className='form-control mb-2'
                                      placeholder={t('About Deposits')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setAboutDepositsRU(e.target.value)
                                      }}
                                      value={aboutDepositsRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('About Deposits (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='aboutDepositsEN'
                                      className='form-control mb-2'
                                      placeholder={t('About Deposits')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setAboutDepositsEN(e.target.value)
                                      }}
                                      value={aboutDepositsEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                              </>
                            )}
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                <PriceInput
                                  labelClass='required fs-5 form-label'
                                  label={t('Security Deposit Amount')}
                                  inputClass='form-control border-right-0'
                                  placeholder={t('Security Deposit Amount')}
                                  value={securityDepositAmount}
                                  onChange={(e: any) => {
                                    setSecurityDepositAmount(e)
                                    removeError('securityDepositAmount')
                                  }}
                                />
                                <div className='text-danger fw-bold mb-2'>
                                  {error[0].securityDepositAmount}
                                </div>
                              </div>
                            </div>
                            <div className='row'>
                              <div className='col-lg-12 my-3 d-flex justify-content-end'>
                                <button className='btn btn-success' onClick={nextToTab2}>
                                  {t('Next')}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='tab-content'>
                          <div className={clsx('tab-pane', {active: tab === '2'})}>
                            {primaryLanguage == 'English' && (
                              <>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Early Pick Up (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='earlyPickUpEN'
                                      className='form-control mb-2'
                                      placeholder={t('Early Pick Up')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setEarlyPickUpEN(e.target.value)
                                        removeError('earlyPickUpEN')
                                      }}
                                      value={earlyPickUpEN}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].earlyPickUpEN}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Early Pick Up (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='earlyPickUpRU'
                                      className='form-control mb-2'
                                      placeholder={t('Early Pick Up')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setEarlyPickUpRU(e.target.value)
                                      }}
                                      value={earlyPickUpRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Early Pick Up (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='earlyPickUpUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Early Pick Up')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setEarlyPickUpUZ(e.target.value)
                                      }}
                                      value={earlyPickUpUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Late Pick Up (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='latePickUpEN'
                                      className='form-control mb-2'
                                      placeholder={t('Late Pick Up')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setLatePickUpEN(e.target.value)
                                        removeError('latePickUpEN')
                                      }}
                                      value={latePickUpEN}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].latePickUpEN}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Late Pick Up (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='latePickUpRU'
                                      className='form-control mb-2'
                                      placeholder={t('Late Pick Up')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setLatePickUpRU(e.target.value)
                                      }}
                                      value={latePickUpRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Late Pick Up (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='latePickUpUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Late Pick Up')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setLatePickUpUZ(e.target.value)
                                      }}
                                      value={latePickUpUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Early Drop Off (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='earlyDropOffEN'
                                      className='form-control mb-2'
                                      placeholder={t('Early Drop Off')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setEarlyDropOffEN(e.target.value)
                                        removeError('earlyDropOffEN')
                                      }}
                                      value={earlyDropOffEN}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].earlyDropOffEN}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Early Drop Off (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='earlyDropOffRU'
                                      className='form-control mb-2'
                                      placeholder={t('Early Drop Off')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setEarlyDropOffRU(e.target.value)
                                      }}
                                      value={earlyDropOffRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Early Drop Off (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='earlyDropOffUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Early Drop Off')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setEarlyDropOffUZ(e.target.value)
                                      }}
                                      value={earlyDropOffUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Late Drop Off (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='lateDropOffEN'
                                      className='form-control mb-2'
                                      placeholder={t('Late Drop Off')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setLateDropOffEN(e.target.value)
                                        removeError('lateDropOffEN')
                                      }}
                                      value={lateDropOffEN}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].lateDropOffEN}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Late Drop Off (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='lateDropOffRU'
                                      className='form-control mb-2'
                                      placeholder={t('Late Drop Off')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setLateDropOffRU(e.target.value)
                                      }}
                                      value={lateDropOffRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Late Drop Off (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='lateDropOffUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Late Drop Off')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setLateDropOffUZ(e.target.value)
                                      }}
                                      value={lateDropOffUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                              </>
                            )}
                            {primaryLanguage == 'Russian' && (
                              <>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Early Pick Up (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='earlyPickUpRU'
                                      className='form-control mb-2'
                                      placeholder={t('Early Pick Up')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setEarlyPickUpRU(e.target.value)
                                        removeError('earlyPickUpRU')
                                      }}
                                      value={earlyPickUpRU}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].earlyPickUpRU}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Early Pick Up (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='earlyPickUpEN'
                                      className='form-control mb-2'
                                      placeholder={t('Early Pick Up')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setEarlyPickUpEN(e.target.value)
                                      }}
                                      value={earlyPickUpEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Early Pick Up (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='earlyPickUpUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Early Pick Up')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setEarlyPickUpUZ(e.target.value)
                                      }}
                                      value={earlyPickUpUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Late Pick Up (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='latePickUpRU'
                                      className='form-control mb-2'
                                      placeholder={t('Late Pick Up')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setLatePickUpRU(e.target.value)
                                        removeError('earlyPickUpRU')
                                      }}
                                      value={latePickUpRU}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].latePickUpRU}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Late Pick Up (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='latePickUpEN'
                                      className='form-control mb-2'
                                      placeholder={t('Late Pick Up')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setLatePickUpEN(e.target.value)
                                      }}
                                      value={latePickUpEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Late Pick Up (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='latePickUpUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Late Pick Up')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setLatePickUpUZ(e.target.value)
                                      }}
                                      value={latePickUpUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Early Drop Off (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='earlyDropOffRU'
                                      className='form-control mb-2'
                                      placeholder={t('Early Drop Off')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setEarlyDropOffRU(e.target.value)
                                        removeError('earlyDropOffRU')
                                      }}
                                      value={earlyDropOffRU}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].earlyDropOffRU}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Early Drop Off (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='earlyDropOffEN'
                                      className='form-control mb-2'
                                      placeholder={t('Early Drop Off')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setEarlyDropOffEN(e.target.value)
                                      }}
                                      value={earlyDropOffEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Early Drop Off (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='earlyDropOffUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Early Drop Off')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setEarlyDropOffUZ(e.target.value)
                                      }}
                                      value={earlyDropOffUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Late Drop Off (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='lateDropOffRU'
                                      className='form-control mb-2'
                                      placeholder={t('Late Drop Off')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setLateDropOffRU(e.target.value)
                                        removeError('earlyDropOffRU')
                                      }}
                                      value={lateDropOffRU}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].lateDropOffRU}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Late Drop Off (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='lateDropOffEN'
                                      className='form-control mb-2'
                                      placeholder={t('Late Drop Off')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setLateDropOffEN(e.target.value)
                                      }}
                                      value={lateDropOffEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Late Drop Off (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='lateDropOffUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Late Drop Off')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setLateDropOffUZ(e.target.value)
                                      }}
                                      value={lateDropOffUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                              </>
                            )}
                            {primaryLanguage == 'Uzbek' && (
                              <>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Early Pick Up (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='earlyPickUpUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Early Pick Up')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setEarlyPickUpUZ(e.target.value)
                                        removeError('earlyPickUpUZ')
                                      }}
                                      value={earlyPickUpUZ}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].earlyPickUpUZ}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Early Pick Up (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='earlyPickUpRU'
                                      className='form-control mb-2'
                                      placeholder={t('Early Pick Up')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setEarlyPickUpRU(e.target.value)
                                      }}
                                      value={earlyPickUpRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Early Pick Up (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='earlyPickUpEN'
                                      className='form-control mb-2'
                                      placeholder={t('Early Pick Up')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setEarlyPickUpEN(e.target.value)
                                      }}
                                      value={earlyPickUpEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Late Pick Up (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='latePickUpUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Late Pick Up')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setLatePickUpUZ(e.target.value)
                                        removeError('earlyPickUpUZ')
                                      }}
                                      value={latePickUpUZ}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].latePickUpUZ}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Late Pick Up (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='latePickUpRU'
                                      className='form-control mb-2'
                                      placeholder={t('Late Pick Up')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setLatePickUpRU(e.target.value)
                                      }}
                                      value={latePickUpRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Late Pick Up (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='latePickUpEN'
                                      className='form-control mb-2'
                                      placeholder={t('Late Pick Up')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setLatePickUpEN(e.target.value)
                                      }}
                                      value={latePickUpEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Early Drop Off (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='earlyDropOffUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Early Drop Off')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setEarlyDropOffUZ(e.target.value)
                                        removeError('earlyDropOffUZ')
                                      }}
                                      value={earlyDropOffUZ}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].earlyDropOffUZ}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Early Drop Off (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='earlyDropOffRU'
                                      className='form-control mb-2'
                                      placeholder={t('Early Drop Off')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setEarlyDropOffRU(e.target.value)
                                      }}
                                      value={earlyDropOffRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Early Drop Off (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='earlyDropOffEN'
                                      className='form-control mb-2'
                                      placeholder={t('Early Drop Off')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setEarlyDropOffEN(e.target.value)
                                      }}
                                      value={earlyDropOffEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Late Drop Off (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='lateDropOffUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Late Drop Off')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setLateDropOffUZ(e.target.value)
                                        removeError('earlyDropOffUZ')
                                      }}
                                      value={lateDropOffUZ}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].lateDropOffUZ}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Late Drop Off (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='lateDropOffRU'
                                      className='form-control mb-2'
                                      placeholder={t('Late Drop Off')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setLateDropOffRU(e.target.value)
                                      }}
                                      value={lateDropOffRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Late Drop Off (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='lateDropOffEN'
                                      className='form-control mb-2'
                                      placeholder={t('Late Drop Off')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setLateDropOffEN(e.target.value)
                                      }}
                                      value={lateDropOffEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                              </>
                            )}
                            <div className='row'>
                              <div className='col-lg-12 my-3 d-flex justify-content-end'>
                                <button
                                  className='btn btn-light-success mx-1'
                                  onClick={() => setTab('1')}
                                >
                                  {t('Back')}
                                </button>
                                <button className='btn btn-success mx-1' onClick={nextToTab3}>
                                  {t('Next')}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='tab-content'>
                          <div className={clsx('tab-pane', {active: tab === '3'})}>
                            {primaryLanguage == 'English' && (
                              <>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Confirmation Policy (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='confirmationPolicyEN'
                                      className='form-control mb-2'
                                      placeholder={t('Confirmation Policy')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setConfirmationPolicyEN(e.target.value)
                                        removeError('confirmationPolicyEN')
                                      }}
                                      value={confirmationPolicyEN}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].confirmationPolicyEN}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Confirmation Policy (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='confirmationPolicyRU'
                                      className='form-control mb-2'
                                      placeholder={t('Confirmation Policy')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setConfirmationPolicyRU(e.target.value)
                                      }}
                                      value={confirmationPolicyRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Confirmation Policy (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='confirmationPolicyUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Confirmation Policy')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setConfirmationPolicyUZ(e.target.value)
                                      }}
                                      value={confirmationPolicyUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Contract Amount Check (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='contractAmountCheckEN'
                                      className='form-control mb-2'
                                      placeholder={t('Contract Amount Check')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setContractAmountCheckEN(e.target.value)
                                        removeError('contractAmountCheckEN')
                                      }}
                                      value={contractAmountCheckEN}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].contractAmountCheckEN}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Contract Amount Check (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='contractAmountCheckRU'
                                      className='form-control mb-2'
                                      placeholder={t('Contract Amount Check')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setContractAmountCheckRU(e.target.value)
                                      }}
                                      value={contractAmountCheckRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Contract Amount Check (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='contractAmountCheckUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Contract Amount Check')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setContractAmountCheckUZ(e.target.value)
                                      }}
                                      value={contractAmountCheckUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Inspection Guidelines (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='inspectionGuidelinesEN'
                                      className='form-control mb-2'
                                      placeholder={t('Inspection Guidelines')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setInspectionGuidelinesEN(e.target.value)
                                        removeError('inspectionGuidelinesEN')
                                      }}
                                      value={inspectionGuidelinesEN}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].inspectionGuidelinesEN}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Inspection Guidelines (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='inspectionGuidelinesRU'
                                      className='form-control mb-2'
                                      placeholder={t('Inspection Guidelines')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setInspectionGuidelinesRU(e.target.value)
                                      }}
                                      value={inspectionGuidelinesRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Inspection Guidelines (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='inspectionGuidelinesUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Inspection Guidelines')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setInspectionGuidelinesUZ(e.target.value)
                                      }}
                                      value={inspectionGuidelinesUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                              </>
                            )}
                            {primaryLanguage == 'Russian' && (
                              <>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Confirmation Policy (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='confirmationPolicyRU'
                                      className='form-control mb-2'
                                      placeholder={t('Confirmation Policy')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setConfirmationPolicyRU(e.target.value)
                                        removeError('confirmationPolicyRU')
                                      }}
                                      value={confirmationPolicyRU}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].confirmationPolicyRU}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Confirmation Policy (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='confirmationPolicyEN'
                                      className='form-control mb-2'
                                      placeholder={t('Confirmation Policy')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setConfirmationPolicyEN(e.target.value)
                                      }}
                                      value={confirmationPolicyEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Confirmation Policy (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='confirmationPolicyUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Confirmation Policy')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setConfirmationPolicyUZ(e.target.value)
                                      }}
                                      value={confirmationPolicyUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Contract Amount Check (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='contractAmountCheckRU'
                                      className='form-control mb-2'
                                      placeholder={t('Contract Amount Check')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setContractAmountCheckRU(e.target.value)
                                        removeError('contractAmountCheckRU')
                                      }}
                                      value={contractAmountCheckRU}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].contractAmountCheckRU}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Contract Amount Check (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='contractAmountCheckEN'
                                      className='form-control mb-2'
                                      placeholder={t('Contract Amount Check')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setContractAmountCheckEN(e.target.value)
                                      }}
                                      value={contractAmountCheckEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Contract Amount Check (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='contractAmountCheckUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Contract Amount Check')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setContractAmountCheckUZ(e.target.value)
                                      }}
                                      value={contractAmountCheckUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Inspection Guidelines (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='inspectionGuidelinesRU'
                                      className='form-control mb-2'
                                      placeholder={t('Inspection Guidelines')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setInspectionGuidelinesRU(e.target.value)
                                        removeError('inspectionGuidelinesRU')
                                      }}
                                      value={inspectionGuidelinesRU}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].inspectionGuidelinesRU}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Inspection Guidelines (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='inspectionGuidelinesEN'
                                      className='form-control mb-2'
                                      placeholder={t('Inspection Guidelines')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setInspectionGuidelinesEN(e.target.value)
                                      }}
                                      value={inspectionGuidelinesEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Inspection Guidelines (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='inspectionGuidelinesUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Inspection Guidelines')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setInspectionGuidelinesUZ(e.target.value)
                                      }}
                                      value={inspectionGuidelinesUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                              </>
                            )}
                            {primaryLanguage == 'Uzbek' && (
                              <>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Confirmation Policy (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='confirmationPolicyUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Confirmation Policy')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setConfirmationPolicyUZ(e.target.value)
                                        removeError('confirmationPolicyUZ')
                                      }}
                                      value={confirmationPolicyUZ}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].confirmationPolicyUZ}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Confirmation Policy (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='confirmationPolicyRU'
                                      className='form-control mb-2'
                                      placeholder={t('Confirmation Policy')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setConfirmationPolicyRU(e.target.value)
                                      }}
                                      value={confirmationPolicyRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Confirmation Policy (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='confirmationPolicyEN'
                                      className='form-control mb-2'
                                      placeholder={t('Confirmation Policy')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setConfirmationPolicyEN(e.target.value)
                                      }}
                                      value={confirmationPolicyEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Contract Amount Check (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='contractAmountCheckUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Contract Amount Check')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setContractAmountCheckUZ(e.target.value)
                                        removeError('contractAmountCheckUZ')
                                      }}
                                      value={contractAmountCheckUZ}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].contractAmountCheckUZ}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Contract Amount Check (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='contractAmountCheckRU'
                                      className='form-control mb-2'
                                      placeholder={t('Contract Amount Check')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setContractAmountCheckRU(e.target.value)
                                      }}
                                      value={contractAmountCheckRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Contract Amount Check (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='contractAmountCheckEN'
                                      className='form-control mb-2'
                                      placeholder={t('Contract Amount Check')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setContractAmountCheckEN(e.target.value)
                                      }}
                                      value={contractAmountCheckEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Inspection Guidelines (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='inspectionGuidelinesUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Inspection Guidelines')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setInspectionGuidelinesUZ(e.target.value)
                                        removeError('inspectionGuidelinesUZ')
                                      }}
                                      value={inspectionGuidelinesUZ}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].inspectionGuidelinesUZ}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Inspection Guidelines (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='inspectionGuidelinesRU'
                                      className='form-control mb-2'
                                      placeholder={t('Inspection Guidelines')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setInspectionGuidelinesRU(e.target.value)
                                      }}
                                      value={inspectionGuidelinesRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Inspection Guidelines (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='inspectionGuidelinesEN'
                                      className='form-control mb-2'
                                      placeholder={t('Inspection Guidelines')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setInspectionGuidelinesEN(e.target.value)
                                      }}
                                      value={inspectionGuidelinesEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                              </>
                            )}
                            <div className='row'>
                              <div className='col-lg-12 my-3 d-flex justify-content-end'>
                                <button
                                  className='btn btn-light-success mx-1'
                                  onClick={() => setTab('2')}
                                >
                                  {t('Back')}
                                </button>
                                <button className='btn btn-success mx-1' onClick={nextToTab4}>
                                  {t('Next')}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='tab-content'>
                          <div className={clsx('tab-pane', {active: tab === '4'})}>
                            {primaryLanguage == 'English' && (
                              <>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Extras (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='extrasEN'
                                      className='form-control mb-2'
                                      placeholder={t('Extras')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setExtrasEN(e.target.value)
                                        removeError('extrasEN')
                                      }}
                                      value={extrasEN}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>{error[0].extrasEN}</div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Extras (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='extrasRU'
                                      className='form-control mb-2'
                                      placeholder={t('Extras')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setExtrasRU(e.target.value)
                                      }}
                                      value={extrasRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>{t('Extras (Uzbek)')}</label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='extrasUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Extras')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setExtrasUZ(e.target.value)
                                      }}
                                      value={extrasUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Taxes And Fess (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='texesAndFessEN'
                                      className='form-control mb-2'
                                      placeholder={t('Taxes And Fess')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setTexesAndFessEN(e.target.value)
                                        removeError('texesAndFessEN')
                                      }}
                                      value={texesAndFessEN}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].texesAndFessEN}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Taxes And Fess (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='texesAndFessRU'
                                      className='form-control mb-2'
                                      placeholder={t('Taxes And Fess')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setTexesAndFessRU(e.target.value)
                                      }}
                                      value={texesAndFessRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Taxes And Fess (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='texesAndFessUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Taxes And Fess')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setTexesAndFessUZ(e.target.value)
                                      }}
                                      value={texesAndFessUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                              </>
                            )}
                            {primaryLanguage == 'Russian' && (
                              <>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Extras (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='extrasRU'
                                      className='form-control mb-2'
                                      placeholder={t('Extras')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setExtrasRU(e.target.value)
                                        removeError('extrasRU')
                                      }}
                                      value={extrasRU}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>{error[0].extrasRU}</div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Extras (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='extrasEN'
                                      className='form-control mb-2'
                                      placeholder={t('Extras')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setExtrasEN(e.target.value)
                                      }}
                                      value={extrasEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>{t('Extras (Uzbek)')}</label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='extrasUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Extras')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setExtrasUZ(e.target.value)
                                      }}
                                      value={extrasUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Taxes And Fess (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='texesAndFessRU'
                                      className='form-control mb-2'
                                      placeholder={t('Taxes And Fess')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setTexesAndFessRU(e.target.value)
                                        removeError('texesAndFessRU')
                                      }}
                                      value={texesAndFessRU}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].texesAndFessRU}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Taxes And Fess (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='texesAndFessEN'
                                      className='form-control mb-2'
                                      placeholder={t('Taxes And Fess')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setTexesAndFessEN(e.target.value)
                                      }}
                                      value={texesAndFessEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Taxes And Fess (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='texesAndFessUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Taxes And Fess')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setTexesAndFessUZ(e.target.value)
                                      }}
                                      value={texesAndFessUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                              </>
                            )}
                            {primaryLanguage == 'Uzbek' && (
                              <>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Extras (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='extrasUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Extras')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setExtrasUZ(e.target.value)
                                        removeError('extrasUZ')
                                      }}
                                      value={extrasUZ}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>{error[0].extrasUZ}</div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Extras (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='extrasRU'
                                      className='form-control mb-2'
                                      placeholder={t('Extras')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setExtrasRU(e.target.value)
                                      }}
                                      value={extrasRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Extras (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='extrasEN'
                                      className='form-control mb-2'
                                      placeholder={t('Extras')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setExtrasEN(e.target.value)
                                      }}
                                      value={extrasEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Taxes And Fess (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='texesAndFessUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Taxes And Fess')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setTexesAndFessUZ(e.target.value)
                                        removeError('texesAndFessUZ')
                                      }}
                                      value={texesAndFessUZ}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].texesAndFessUZ}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Taxes And Fess (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='texesAndFessRU'
                                      className='form-control mb-2'
                                      placeholder={t('Taxes And Fess')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setTexesAndFessRU(e.target.value)
                                      }}
                                      value={texesAndFessRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Taxes And Fess (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='texesAndFessEN'
                                      className='form-control mb-2'
                                      placeholder={t('Taxes And Fess')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setTexesAndFessEN(e.target.value)
                                      }}
                                      value={texesAndFessEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                              </>
                            )}
                            <div className='row'>
                              <div className='col-lg-12 my-3 d-flex justify-content-end'>
                                <button
                                  className='btn btn-light-success mx-1'
                                  onClick={() => setTab('3')}
                                >
                                  {t('Back')}
                                </button>
                                <button className='btn btn-success mx-1' onClick={nextToTab5}>
                                  {t('Next')}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='tab-content'>
                          <div className={clsx('tab-pane', {active: tab === '5'})}>
                            {/* {
                                                            primaryLanguage == "English" && (
                                                                <>
                                                                    <div className="row">
                                                                        <div className="col-lg-4 my-3">
                                                                            <label className="fs-4 required form-label">{t('Modifications (English)')}</label>
                                                                            <textarea name="modificationsEN" className="form-control mb-2" placeholder={t("Modifications")} cols={30} rows={4} onChange={(e) => { setModificationsEN(e.target.value); removeError("modificationsEN"); }} value={modificationsEN}></textarea>
                                                                            <div className='text-danger fw-bold'>{error[0].modificationsEN}</div>
                                                                        </div>
                                                                        <div className="col-lg-4 my-3">
                                                                            <label className="fs-4 form-label">{t('Modifications (Russian)')}</label>
                                                                            <textarea name="modificationsRU" className="form-control mb-2" placeholder={t("Modifications")} cols={30} rows={4} onChange={(e) => { setModificationsRU(e.target.value); }} value={modificationsRU}></textarea>
                                                                        </div>
                                                                        <div className="col-lg-4 my-3">
                                                                            <label className="fs-4 form-label">{t('Modifications (Uzbek)')}</label>
                                                                            <textarea name="modificationsUZ" className="form-control mb-2" placeholder={t("Modifications")} cols={30} rows={4} onChange={(e) => { setModificationsUZ(e.target.value); }} value={modificationsUZ}></textarea>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="col-lg-4 my-3">
                                                                            <label className="fs-4 required form-label">{t('No Shows (English)')}</label>
                                                                            <textarea name="noShowsEN" className="form-control mb-2" placeholder={t("No Shows")} cols={30} rows={4} onChange={(e) => { setNoShowsEN(e.target.value); removeError("noShowsEN"); }} value={noShowsEN}></textarea>
                                                                            <div className='text-danger fw-bold'>{error[0].noShowsEN}</div>
                                                                        </div>
                                                                        <div className="col-lg-4 my-3">
                                                                            <label className="fs-4 form-label">{t('No Shows (Russian)')}</label>
                                                                            <textarea name="noShowsRU" className="form-control mb-2" placeholder={t("No Shows")} cols={30} rows={4} onChange={(e) => { setNoShowsRU(e.target.value); }} value={noShowsRU}></textarea>
                                                                        </div>
                                                                        <div className="col-lg-4 my-3">
                                                                            <label className="fs-4 form-label">{t('No Shows (Uzbek)')}</label>
                                                                            <textarea name="noShowsUZ" className="form-control mb-2" placeholder={t("No Shows")} cols={30} rows={4} onChange={(e) => { setNoShowsUZ(e.target.value); }} value={noShowsUZ}></textarea>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )
                                                        }
                                                        {
                                                            primaryLanguage == "Russian" && (
                                                                <>
                                                                    <div className="row">
                                                                        <div className="col-lg-4 my-3">
                                                                            <label className="fs-4 required form-label">{t('Modifications (Russian)')}</label>
                                                                            <textarea name="modificationsRU" className="form-control mb-2" placeholder={t("Modifications")} cols={30} rows={4} onChange={(e) => { setModificationsRU(e.target.value); removeError("modificationsRU"); }} value={modificationsRU}></textarea>
                                                                            <div className='text-danger fw-bold'>{error[0].modificationsRU}</div>
                                                                        </div>
                                                                        <div className="col-lg-4 my-3">
                                                                            <label className="fs-4 form-label">{t('Modifications (English)')}</label>
                                                                            <textarea name="modificationsEN" className="form-control mb-2" placeholder={t("Modifications")} cols={30} rows={4} onChange={(e) => { setModificationsEN(e.target.value); }} value={modificationsEN}></textarea>
                                                                        </div>
                                                                        <div className="col-lg-4 my-3">
                                                                            <label className="fs-4 form-label">{t('Modifications (Uzbek)')}</label>
                                                                            <textarea name="modificationsUZ" className="form-control mb-2" placeholder={t("Modifications")} cols={30} rows={4} onChange={(e) => { setModificationsUZ(e.target.value); }} value={modificationsUZ}></textarea>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="col-lg-4 my-3">
                                                                            <label className="fs-4 required form-label">{t('No Shows (Russian)')}</label>
                                                                            <textarea name="noShowsRU" className="form-control mb-2" placeholder={t("No Shows")} cols={30} rows={4} onChange={(e) => { setNoShowsRU(e.target.value); removeError("noShowsRU"); }} value={noShowsRU}></textarea>
                                                                            <div className='text-danger fw-bold'>{error[0].noShowsRU}</div>
                                                                        </div>
                                                                        <div className="col-lg-4 my-3">
                                                                            <label className="fs-4 form-label">{t('No Shows (English)')}</label>
                                                                            <textarea name="noShowsEN" className="form-control mb-2" placeholder={t("No Shows")} cols={30} rows={4} onChange={(e) => { setNoShowsEN(e.target.value); }} value={noShowsEN}></textarea>
                                                                        </div>
                                                                        <div className="col-lg-4 my-3">
                                                                            <label className="fs-4 form-label">{t('No Shows (Uzbek)')}</label>
                                                                            <textarea name="noShowsUZ" className="form-control mb-2" placeholder={t("No Shows")} cols={30} rows={4} onChange={(e) => { setNoShowsUZ(e.target.value); }} value={noShowsUZ}></textarea>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )
                                                        }
                                                        {
                                                            primaryLanguage == "Uzbek" && (
                                                                <>
                                                                    <div className="row">
                                                                        <div className="col-lg-4 my-3">
                                                                            <label className="fs-4 required form-label">{t('Modifications (Uzbek)')}</label>
                                                                            <textarea name="modificationsUZ" className="form-control mb-2" placeholder={t("Modifications")} cols={30} rows={4} onChange={(e) => { setModificationsUZ(e.target.value); removeError("modificationsUZ"); }} value={modificationsUZ}></textarea>
                                                                            <div className='text-danger fw-bold'>{error[0].modificationsUZ}</div>
                                                                        </div>
                                                                        <div className="col-lg-4 my-3">
                                                                            <label className="fs-4 form-label">{t('Modifications (Russian)')}</label>
                                                                            <textarea name="modificationsRU" className="form-control mb-2" placeholder={t("Modifications")} cols={30} rows={4} onChange={(e) => { setModificationsRU(e.target.value); }} value={modificationsRU}></textarea>
                                                                        </div>
                                                                        <div className="col-lg-4 my-3">
                                                                            <label className="fs-4 form-label">{t('Modifications (English)')}</label>
                                                                            <textarea name="modificationsEN" className="form-control mb-2" placeholder={t("Modifications")} cols={30} rows={4} onChange={(e) => { setModificationsEN(e.target.value); }} value={modificationsEN}></textarea>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="col-lg-4 my-3">
                                                                            <label className="fs-4 required form-label">{t('No Shows (Uzbek)')}</label>
                                                                            <textarea name="noShowsUZ" className="form-control mb-2" placeholder={t("No Shows")} cols={30} rows={4} onChange={(e) => { setNoShowsUZ(e.target.value); removeError("noShowsUZ"); }} value={noShowsUZ}></textarea>
                                                                            <div className='text-danger fw-bold'>{error[0].noShowsUZ}</div>
                                                                        </div>
                                                                        <div className="col-lg-4 my-3">
                                                                            <label className="fs-4 form-label">{t('No Shows (Russian)')}</label>
                                                                            <textarea name="noShowsRU" className="form-control mb-2" placeholder={t("No Shows")} cols={30} rows={4} onChange={(e) => { setNoShowsRU(e.target.value); }} value={noShowsRU}></textarea>
                                                                        </div>
                                                                        <div className="col-lg-4 my-3">
                                                                            <label className="fs-4 form-label">{t('No Shows (English)')}</label>
                                                                            <textarea name="noShowsEN" className="form-control mb-2" placeholder={t("No Shows")} cols={30} rows={4} onChange={(e) => { setNoShowsEN(e.target.value); }} value={noShowsEN}></textarea>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )
                                                        } */}
                            <div className='row'>
                              <div className='col-lg-12 mt-3'>
                                <label className='fs-3 form-label fw-bolder'>
                                  {t('Cancellation Policy')}
                                </label>
                              </div>
                              <div className='col-lg-12 my-5'>
                                <label className='d-flex text-start' data-kt-button='true'>
                                  {/* <!--begin::Radio--> */}
                                  <span className='form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1'>
                                    <input
                                      className='form-check-input'
                                      type='checkbox'
                                      name='byDay'
                                      value='true'
                                      checked={isNonRefundable}
                                      onChange={(e) => {
                                        handleNonRefundableChange(e)
                                        removeError('isNonRefundable')
                                      }}
                                    />
                                  </span>
                                  {/* <!--end::Radio--> */}
                                  {/* <!--begin::Info--> */}
                                  <span className='ms-5'>
                                    <span className='fs-4 fw-bold text-gray-800 d-block'>
                                      {' '}
                                      {t('Non-refundable')}
                                    </span>
                                  </span>
                                  {/* <!--end::Info--> */}
                                </label>
                                <label className='form-label'>
                                  {t(
                                    'Guest will pay the full amount if they cancel after reservation.'
                                  )}
                                </label>
                              </div>
                              <div className='col-lg-12 my-3'>
                                <label className='d-flex text-start' data-kt-button='true'>
                                  <span className='form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1'>
                                    <input
                                      className='form-check-input'
                                      type='checkbox'
                                      name='freeCancellation'
                                      value='true'
                                      checked={isFreeCancellation}
                                      onChange={(e) => {
                                        handleFreeCancellationChange(e)
                                        removeError('isNonRefundable')
                                      }}
                                    />
                                  </span>
                                  <span className='ms-5'>
                                    <span className='fs-4 fw-bold text-gray-800 d-block'>
                                      {t('Free Cancellation rules')}
                                    </span>
                                  </span>
                                </label>
                              </div>
                              {isFreeCancellation && (
                                <>
                                  <div className='col-lg-6 my-3'>
                                    <div className='row'>
                                      <div className='col-lg-12 my-5'>
                                        <label className='fs-5 form-label fw-semibold'>
                                          {t(
                                            'How many days before arrival can guests cancel their booking for free?'
                                          )}
                                        </label>
                                      </div>
                                      <div className='col-lg-12'>
                                        <ul className='nav nav-pills nav-fill'>
                                          <li className='nav-item'>
                                            <button
                                              className={`nav-link tab-link ${
                                                policyTab == '1' ? 'active' : ''
                                              }`}
                                              onClick={() => setPolicyTab('1')}
                                            >
                                              {t('1 Day')}
                                            </button>
                                          </li>
                                          <li className='nav-item'>
                                            <button
                                              className={`nav-link tab-link ${
                                                policyTab == '5' ? 'active' : ''
                                              }`}
                                              onClick={() => setPolicyTab('5')}
                                            >
                                              {t('5 Days')}
                                            </button>
                                          </li>
                                          <li className='nav-item'>
                                            <button
                                              className={`nav-link tab-link ${
                                                policyTab == '14' ? 'active' : ''
                                              }`}
                                              onClick={() => setPolicyTab('14')}
                                            >
                                              {t('14 Days')}
                                            </button>
                                          </li>
                                          <li className='nav-item'>
                                            <button
                                              className={`nav-link tab-link ${
                                                policyTab == '30' ? 'active' : ''
                                              }`}
                                              onClick={() => setPolicyTab('30')}
                                            >
                                              {t('30 Days')}
                                            </button>
                                          </li>
                                        </ul>
                                      </div>
                                      <div className='col-lg-12'>
                                        {policyTab == '1' && (
                                          <label className='fs-5 form-label cursor-pointer my-10 d-flex'>
                                            <i className='fa-regular fa-clock text-success fs-4 mt-1 mx-2'></i>{' '}
                                            <span>
                                              {t(
                                                'Guests love flexibility - free cancellation rates are generally the most booked rates on our site. Get your first booking sooner by allowing guestes to cancle up to 1 days before check-in.'
                                              )}
                                            </span>
                                          </label>
                                        )}
                                        {policyTab == '5' && (
                                          <label className='fs-5 form-label cursor-pointer my-10 d-flex'>
                                            <i className='fa-regular fa-clock text-success fs-4 mt-1 mx-2'></i>{' '}
                                            <span>
                                              {t(
                                                'Guests love flexibility - free cancellation rates are generally the most booked rates on our site. Get your first booking sooner by allowing guestes to cancle up to 5 days before check-in.'
                                              )}
                                            </span>
                                          </label>
                                        )}
                                        {policyTab == '14' && (
                                          <label className='fs-5 form-label cursor-pointer my-10 d-flex'>
                                            <i className='fa-regular fa-clock text-success fs-4 mt-1 mx-2'></i>{' '}
                                            <span>
                                              {t(
                                                'Guests love flexibility - free cancellation rates are generally the most booked rates on our site. Get your first booking sooner by allowing guestes to cancle up to 14 days before check-in.'
                                              )}
                                            </span>
                                          </label>
                                        )}
                                        {policyTab == '30' && (
                                          <label className='fs-5 form-label cursor-pointer my-10 d-flex'>
                                            <i className='fa-regular fa-clock text-success fs-4 mt-1 mx-2'></i>{' '}
                                            <span>
                                              {t(
                                                'Guests love flexibility - free cancellation rates are generally the most booked rates on our site. Get your first booking sooner by allowing guestes to cancle up to 30 days before check-in.'
                                              )}
                                            </span>
                                          </label>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className='col-lg-6 my-3'>
                                    <div className='row'>
                                      <div className='col-lg-12 my-5'>
                                        <label className='fs-5 form-label fw-semibold'>
                                          {t(
                                            'What are the fees if they cancel within these days before check in:'
                                          )}
                                        </label>
                                      </div>
                                      <div className='col-lg-6'>
                                        <label className='required fs-4 form-label'>
                                          {t('Days before check in')}
                                        </label>
                                      </div>
                                      <div className='col-lg-6'>
                                        <label className='required fs-4 form-label'>
                                          {t('Fee')}
                                        </label>
                                      </div>
                                      {fee.map((field, index) => (
                                        <div key={index} className='row'>
                                          <div className='col-lg-6 my-3'>
                                            <Select
                                              name='beforeCheckinDays[]'
                                              id='beforeCheckinDaysList'
                                              placeholder={t('Select Days')}
                                              isSearchable={true}
                                              isDisabled={field.day == '0' || field.day == '1'}
                                              options={filterDaysList(fee)}
                                              value={getInitialBeforeCheckinDaysList(
                                                policyTab
                                              ).find((option) => option.value === field.day)}
                                              onChange={(e: any) =>
                                                handleFieldChange(index, 'day', e.value)
                                              }
                                            />
                                          </div>
                                          <div className='col-lg-6 my-3'>
                                            <Select
                                              name='percentage[]'
                                              id='percentageList'
                                              placeholder={t('Select')}
                                              isSearchable={true}
                                              // options={filterPercentageList(fee)}
                                              options={initialPercentageList}
                                              value={
                                                initialPercentageList.find(
                                                  (option) => option.value === field.percentage
                                                ) || null
                                              }
                                              onChange={(e: any) =>
                                                handleFieldChange(index, 'percentage', e.value)
                                              }
                                            />
                                          </div>
                                          {((index > 0 && policyTab == '1') ||
                                            (index > 1 && policyTab != '1')) && (
                                            <div className='col-lg-12 d-flex justify-content-end my-3'>
                                              <button
                                                className='btn btn-danger mb-2'
                                                onClick={() => handleRemoveField(index)}
                                              >
                                                {t('Remove')}
                                              </button>
                                            </div>
                                          )}
                                        </div>
                                      ))}
                                      <div className='col-lg-12 d-flex justify-content-end my-3'>
                                        <button
                                          className='btn btn-success mb-2'
                                          onClick={handleAddField}
                                        >
                                          {t('Add More')}
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                            {/* <!--end::Input group--> */}
                            {primaryLanguage == 'English' && (
                              <>
                                {/* <!--begin::Input group--> */}
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Cancellation Policy (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <div
                                      id='cancellationEN'
                                      ref={divRefEN}
                                      className='form-control h-200px'
                                      style={{overflow: 'auto'}}
                                    >
                                      {isFreeCancellation && (
                                        <>
                                          <ul>
                                            <li>
                                              <span className='fw-bold text-dark'>
                                                Free cancellation:
                                              </span>{' '}
                                              You can cancel for free up to{' '}
                                              {cancellationDay[0]['cancellationDay'] == '1'
                                                ? cancellationDay[0]['cancellationDay'] + ' day'
                                                : cancellationDay[0]['cancellationDay'] +
                                                  ' days'}{' '}
                                              before check-in. No charges will apply.
                                            </li>
                                            {cancellationDay[0]['fee'].map(
                                              (fee: any, index: any) => {
                                                return (
                                                  <li key={index}>
                                                    If you cancel{' '}
                                                    {fee['day'] == '0'
                                                      ? 'less than 24 hours'
                                                      : fee['day'] + ' days'}{' '}
                                                    before check-in, you will be charged{' '}
                                                    {fee['percentage']}% of the total booking price.
                                                  </li>
                                                )
                                              }
                                            )}
                                            <li>
                                              If you do not show up for your booking, no refund will
                                              be issued.
                                            </li>
                                            <li>
                                              Once you check in, no refund will be provided for any
                                              unused days or early check-out.
                                            </li>
                                          </ul>
                                        </>
                                      )}
                                      {isNonRefundable == true && (
                                        <>
                                          <ul>
                                            <li
                                              className='text-dark'
                                              style={{fontWeight: 'bolder'}}
                                            >
                                              <span>Non-refundable</span>
                                            </li>
                                          </ul>
                                          <p>
                                            You will pay the full amount if you can cancel the
                                            reservation.
                                          </p>
                                        </>
                                      )}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Cancellation Policy (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <div
                                      id='cancellationRU'
                                      ref={divRefRU}
                                      className='form-control h-200px'
                                      style={{overflow: 'auto'}}
                                    >
                                      {isFreeCancellation && (
                                        <>
                                          <ul>
                                            <li>
                                              <span className='fw-bold text-dark'>
                                                Бесплатная отмена:
                                              </span>{' '}
                                              Вы можете отменить бронирование бесплатно за{' '}
                                              {cancellationDay[0]['cancellationDay']} дней до
                                              заезда. Плата не взимается.
                                            </li>
                                            {cancellationDay[0]['fee'].map(
                                              (fee: any, index: any) => {
                                                return (
                                                  <li key={index}>
                                                    Если вы отмените бронирование{' '}
                                                    {fee['day'] == '0'
                                                      ? 'менее чем за 24 часа до'
                                                      : 'за ' + fee['day'] + ' дней'}{' '}
                                                    до заезда, с вас будет взиматься{' '}
                                                    {fee['percentage']}% от общей стоимости
                                                    бронирования.
                                                  </li>
                                                )
                                              }
                                            )}
                                            <li>
                                              Если вы не приедете в объект размещения или не
                                              воспользуетесь бронированием, возврат средств не
                                              производится.
                                            </li>
                                            <li>
                                              После регистрации заезда возврат средств за
                                              неиспользованные дни или ранний выезд не производится.
                                            </li>
                                          </ul>
                                        </>
                                      )}
                                      {isNonRefundable == true && (
                                        <>
                                          <ul>
                                            <li
                                              className='text-dark'
                                              style={{fontWeight: 'bolder'}}
                                            >
                                              <span>Нет возврата</span>
                                            </li>
                                          </ul>
                                          <p>
                                            Вы заплатите полную сумму, если отмените бронирование.
                                          </p>
                                        </>
                                      )}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Cancellation Policy (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <div
                                      id='cancellationPolicyUZ'
                                      ref={divRefUZ}
                                      className='form-control h-200px'
                                      style={{overflow: 'auto'}}
                                    >
                                      {isFreeCancellation && (
                                        <>
                                          <ul>
                                            <li>
                                              <span className='fw-bold text-dark'>
                                                Bepul bekor qilish:
                                              </span>{' '}
                                              Bron sanasidan {cancellationDay[0]['cancellationDay']}{' '}
                                              kun oldin bepul bekor qilishingiz mumkin. Hech qanday
                                              to‘lov olinmaydi.
                                            </li>
                                            {cancellationDay[0]['fee'].map(
                                              (fee: any, index: any) => {
                                                return (
                                                  <li key={index}>
                                                    Agar bron
                                                    {fee['day'] == '0'
                                                      ? 'ni 24 soatdan kam vaqt qolganida'
                                                      : ' sanasidan ' +
                                                        fee['day'] +
                                                        ' kun oldin'}{' '}
                                                    bekor qilsangiz, sizdan jami bron narxining{' '}
                                                    {fee['percentage']}% ushlab qolinadi.
                                                  </li>
                                                )
                                              }
                                            )}
                                            <li>
                                              Agar siz bron sanasida manzilga kelmasangiz va
                                              foydalanmasangiz, to'lov qaytarilmaydi.
                                            </li>
                                            <li>
                                              Bron kunidan so'ng, foydalanilmagan kunlar uchun yoki
                                              erta chiqib ketilganligi uchun to'lovlar
                                              qaytarilmaydi.
                                            </li>
                                          </ul>
                                        </>
                                      )}
                                      {isNonRefundable == true && (
                                        <>
                                          <ul>
                                            <li
                                              className='text-dark'
                                              style={{fontWeight: 'bolder'}}
                                            >
                                              <span>Qaytarilmaydi</span>
                                            </li>
                                          </ul>
                                          <p>
                                            Agar siz bronni bekor qilsangiz, to'lovingiz to'liq
                                            miqdorda ushlab qolinadi va qaytarib berilmaydi
                                          </p>
                                        </>
                                      )}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                              </>
                            )}
                            {primaryLanguage == 'Russian' && (
                              <>
                                {/* <!--begin::Input group--> */}
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Cancellation Policy (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <div
                                      id='cancellationRU'
                                      ref={divRefRU}
                                      className='form-control h-200px'
                                      style={{overflow: 'auto'}}
                                    >
                                      {isFreeCancellation && (
                                        <>
                                          <ul>
                                            <li>
                                              <span className='fw-bold text-dark'>
                                                Бесплатная отмена:
                                              </span>{' '}
                                              Вы можете отменить бронирование бесплатно за{' '}
                                              {cancellationDay[0]['cancellationDay']} дней до
                                              заезда. Плата не взимается.
                                            </li>
                                            {cancellationDay[0]['fee'].map(
                                              (fee: any, index: any) => {
                                                return (
                                                  <li key={index}>
                                                    Если вы отмените бронирование{' '}
                                                    {fee['day'] == '0'
                                                      ? 'менее чем за 24 часа до'
                                                      : 'за ' + fee['day'] + ' дней'}{' '}
                                                    до заезда, с вас будет взиматься{' '}
                                                    {fee['percentage']}% от общей стоимости
                                                    бронирования.
                                                  </li>
                                                )
                                              }
                                            )}
                                            <li>
                                              Если вы не приедете в объект размещения или не
                                              воспользуетесь бронированием, возврат средств не
                                              производится.
                                            </li>
                                            <li>
                                              После регистрации заезда возврат средств за
                                              неиспользованные дни или ранний выезд не производится.
                                            </li>
                                          </ul>
                                        </>
                                      )}
                                      {isNonRefundable == true && (
                                        <>
                                          <ul>
                                            <li
                                              className='text-dark'
                                              style={{fontWeight: 'bolder'}}
                                            >
                                              <span>Нет возврата</span>
                                            </li>
                                          </ul>
                                          <p>
                                            Вы заплатите полную сумму, если отмените бронирование.
                                          </p>
                                        </>
                                      )}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Cancellation Policy (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <div
                                      id='cancellationEN'
                                      ref={divRefEN}
                                      className='form-control h-200px'
                                      style={{overflow: 'auto'}}
                                    >
                                      {isFreeCancellation && (
                                        <>
                                          <ul>
                                            <li>
                                              <span className='fw-bold text-dark'>
                                                Free cancellation:
                                              </span>{' '}
                                              You can cancel for free up to{' '}
                                              {cancellationDay[0]['cancellationDay'] == '1'
                                                ? cancellationDay[0]['cancellationDay'] + ' day'
                                                : cancellationDay[0]['cancellationDay'] +
                                                  ' days'}{' '}
                                              before check-in. No charges will apply.
                                            </li>
                                            {cancellationDay[0]['fee'].map(
                                              (fee: any, index: any) => {
                                                return (
                                                  <li key={index}>
                                                    If you cancel{' '}
                                                    {fee['day'] == '0'
                                                      ? 'less than 24 hours'
                                                      : fee['day'] + ' days'}{' '}
                                                    before check-in, you will be charged{' '}
                                                    {fee['percentage']}% of the total booking price.
                                                  </li>
                                                )
                                              }
                                            )}
                                            <li>
                                              If you do not show up for your booking, no refund will
                                              be issued.
                                            </li>
                                            <li>
                                              Once you check in, no refund will be provided for any
                                              unused days or early check-out.
                                            </li>
                                          </ul>
                                        </>
                                      )}
                                      {isNonRefundable == true && (
                                        <>
                                          <ul>
                                            <li
                                              className='text-dark'
                                              style={{fontWeight: 'bolder'}}
                                            >
                                              <span>Non-refundable</span>
                                            </li>
                                          </ul>
                                          <p>
                                            You will pay the full amount if you can cancel the
                                            reservation.
                                          </p>
                                        </>
                                      )}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Cancellation Policy (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <div
                                      id='cancellationPolicyUZ'
                                      ref={divRefUZ}
                                      className='form-control h-200px'
                                      style={{overflow: 'auto'}}
                                    >
                                      {isFreeCancellation && (
                                        <>
                                          <ul>
                                            <li>
                                              <span className='fw-bold text-dark'>
                                                Bepul bekor qilish:
                                              </span>{' '}
                                              Bron sanasidan {cancellationDay[0]['cancellationDay']}{' '}
                                              kun oldin bepul bekor qilishingiz mumkin. Hech qanday
                                              to‘lov olinmaydi.
                                            </li>
                                            {cancellationDay[0]['fee'].map(
                                              (fee: any, index: any) => {
                                                return (
                                                  <li key={index}>
                                                    Agar bron
                                                    {fee['day'] == '0'
                                                      ? 'ni 24 soatdan kam vaqt qolganida'
                                                      : ' sanasidan ' +
                                                        fee['day'] +
                                                        ' kun oldin'}{' '}
                                                    bekor qilsangiz, sizdan jami bron narxining{' '}
                                                    {fee['percentage']}% ushlab qolinadi.
                                                  </li>
                                                )
                                              }
                                            )}
                                            <li>
                                              Agar siz bron sanasida manzilga kelmasangiz va
                                              foydalanmasangiz, to'lov qaytarilmaydi.
                                            </li>
                                            <li>
                                              Bron kunidan so'ng, foydalanilmagan kunlar uchun yoki
                                              erta chiqib ketilganligi uchun to'lovlar
                                              qaytarilmaydi.
                                            </li>
                                          </ul>
                                        </>
                                      )}
                                      {isNonRefundable == true && (
                                        <>
                                          <ul>
                                            <li
                                              className='text-dark'
                                              style={{fontWeight: 'bolder'}}
                                            >
                                              <span>Qaytarilmaydi</span>
                                            </li>
                                          </ul>
                                          <p>
                                            Agar siz bronni bekor qilsangiz, to'lovingiz to'liq
                                            miqdorda ushlab qolinadi va qaytarib berilmaydi
                                          </p>
                                        </>
                                      )}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                              </>
                            )}
                            {primaryLanguage == 'Uzbek' && (
                              <>
                                {/* <!--begin::Input group--> */}
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Cancellation Policy (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <div
                                      id='cancellationPolicyUZ'
                                      ref={divRefUZ}
                                      className='form-control h-200px'
                                      style={{overflow: 'auto'}}
                                    >
                                      {isFreeCancellation && (
                                        <>
                                          <ul>
                                            <li>
                                              <span className='fw-bold text-dark'>
                                                Bepul bekor qilish:
                                              </span>{' '}
                                              Bron sanasidan {cancellationDay[0]['cancellationDay']}{' '}
                                              kun oldin bepul bekor qilishingiz mumkin. Hech qanday
                                              to‘lov olinmaydi.
                                            </li>
                                            {cancellationDay[0]['fee'].map(
                                              (fee: any, index: any) => {
                                                return (
                                                  <li key={index}>
                                                    Agar bron
                                                    {fee['day'] == '0'
                                                      ? 'ni 24 soatdan kam vaqt qolganida'
                                                      : ' sanasidan ' +
                                                        fee['day'] +
                                                        ' kun oldin'}{' '}
                                                    bekor qilsangiz, sizdan jami bron narxining{' '}
                                                    {fee['percentage']}% ushlab qolinadi.
                                                  </li>
                                                )
                                              }
                                            )}
                                            <li>
                                              Agar siz bron sanasida manzilga kelmasangiz va
                                              foydalanmasangiz, to'lov qaytarilmaydi.
                                            </li>
                                            <li>
                                              Bron kunidan so'ng, foydalanilmagan kunlar uchun yoki
                                              erta chiqib ketilganligi uchun to'lovlar
                                              qaytarilmaydi.
                                            </li>
                                          </ul>
                                        </>
                                      )}
                                      {isNonRefundable == true && (
                                        <>
                                          <ul>
                                            <li
                                              className='text-dark'
                                              style={{fontWeight: 'bolder'}}
                                            >
                                              <span>Qaytarilmaydi</span>
                                            </li>
                                          </ul>
                                          <p>
                                            Agar siz bronni bekor qilsangiz, to'lovingiz to'liq
                                            miqdorda ushlab qolinadi va qaytarib berilmaydi
                                          </p>
                                        </>
                                      )}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Cancellation Policy (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <div
                                      id='cancellationRU'
                                      ref={divRefRU}
                                      className='form-control h-200px'
                                      style={{overflow: 'auto'}}
                                    >
                                      {isFreeCancellation && (
                                        <>
                                          <ul>
                                            <li>
                                              <span className='fw-bold text-dark'>
                                                Бесплатная отмена:
                                              </span>{' '}
                                              Вы можете отменить бронирование бесплатно за{' '}
                                              {cancellationDay[0]['cancellationDay']} дней до
                                              заезда. Плата не взимается.
                                            </li>
                                            {cancellationDay[0]['fee'].map(
                                              (fee: any, index: any) => {
                                                return (
                                                  <li key={index}>
                                                    Если вы отмените бронирование{' '}
                                                    {fee['day'] == '0'
                                                      ? 'менее чем за 24 часа до'
                                                      : 'за ' + fee['day'] + ' дней'}{' '}
                                                    до заезда, с вас будет взиматься{' '}
                                                    {fee['percentage']}% от общей стоимости
                                                    бронирования.
                                                  </li>
                                                )
                                              }
                                            )}
                                            <li>
                                              Если вы не приедете в объект размещения или не
                                              воспользуетесь бронированием, возврат средств не
                                              производится.
                                            </li>
                                            <li>
                                              После регистрации заезда возврат средств за
                                              неиспользованные дни или ранний выезд не производится.
                                            </li>
                                          </ul>
                                        </>
                                      )}
                                      {isNonRefundable == true && (
                                        <>
                                          <ul>
                                            <li
                                              className='text-dark'
                                              style={{fontWeight: 'bolder'}}
                                            >
                                              <span>Нет возврата</span>
                                            </li>
                                          </ul>
                                          <p>
                                            Вы заплатите полную сумму, если отмените бронирование.
                                          </p>
                                        </>
                                      )}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Cancellation Policy (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <div
                                      id='cancellationEN'
                                      ref={divRefEN}
                                      className='form-control h-200px'
                                      style={{overflow: 'auto'}}
                                    >
                                      {isFreeCancellation && (
                                        <>
                                          <ul>
                                            <li>
                                              <span className='fw-bold text-dark'>
                                                Free cancellation:
                                              </span>{' '}
                                              You can cancel for free up to{' '}
                                              {cancellationDay[0]['cancellationDay'] == '1'
                                                ? cancellationDay[0]['cancellationDay'] + ' day'
                                                : cancellationDay[0]['cancellationDay'] +
                                                  ' days'}{' '}
                                              before check-in. No charges will apply.
                                            </li>
                                            {cancellationDay[0]['fee'].map(
                                              (fee: any, index: any) => {
                                                return (
                                                  <li key={index}>
                                                    If you cancel{' '}
                                                    {fee['day'] == '0'
                                                      ? 'less than 24 hours'
                                                      : fee['day'] + ' days'}{' '}
                                                    before check-in, you will be charged{' '}
                                                    {fee['percentage']}% of the total booking price.
                                                  </li>
                                                )
                                              }
                                            )}
                                            <li>
                                              If you do not show up for your booking, no refund will
                                              be issued.
                                            </li>
                                            <li>
                                              Once you check in, no refund will be provided for any
                                              unused days or early check-out.
                                            </li>
                                          </ul>
                                        </>
                                      )}
                                      {isNonRefundable == true && (
                                        <>
                                          <ul>
                                            <li
                                              className='text-dark'
                                              style={{fontWeight: 'bolder'}}
                                            >
                                              <span>Non-refundable</span>
                                            </li>
                                          </ul>
                                          <p>
                                            You will pay the full amount if you can cancel the
                                            reservation.
                                          </p>
                                        </>
                                      )}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                              </>
                            )}
                            <div className='row'>
                              <div className='col-lg-12 my-3 d-flex justify-content-end'>
                                <button
                                  className='btn btn-light-success mx-1'
                                  onClick={() => setTab('4')}
                                >
                                  {t('Back')}
                                </button>
                                <button className='btn btn-success mx-1' onClick={nextToTab6}>
                                  {t('Next')}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='tab-content'>
                          <div className={clsx('tab-pane', {active: tab === '6'})}>
                            {primaryLanguage == 'English' && (
                              <>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Accidents & BreakDowns (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='accidentsAndBreakdownsEN'
                                      className='form-control mb-2'
                                      placeholder={t('Accidents & BreakDowns')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setAccidentsAndBreakdownsEN(e.target.value)
                                        removeError('accidentsAndBreakdownsEN')
                                      }}
                                      value={accidentsAndBreakdownsEN}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].accidentsAndBreakdownsEN}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Accidents & BreakDowns (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='accidentsAndBreakdownsRU'
                                      className='form-control mb-2'
                                      placeholder={t('Accidents & BreakDowns')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setAccidentsAndBreakdownsRU(e.target.value)
                                      }}
                                      value={accidentsAndBreakdownsRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Accidents & BreakDowns (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='accidentsAndBreakdownsUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Accidents & BreakDowns')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setAccidentsAndBreakdownsUZ(e.target.value)
                                      }}
                                      value={accidentsAndBreakdownsUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Roadside Assistance (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='roadsideAssistanceEN'
                                      className='form-control mb-2'
                                      placeholder={t('Roadside Assistance')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setRoadsideAssistanceEN(e.target.value)
                                        removeError('roadsideAssistanceEN')
                                      }}
                                      value={roadsideAssistanceEN}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].roadsideAssistanceEN}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Roadside Assistance (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='roadsideAssistanceRU'
                                      className='form-control mb-2'
                                      placeholder={t('Roadside Assistance')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setRoadsideAssistanceRU(e.target.value)
                                      }}
                                      value={roadsideAssistanceRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Roadside Assistance (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='roadsideAssistanceUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Roadside Assistance')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setRoadsideAssistanceUZ(e.target.value)
                                      }}
                                      value={roadsideAssistanceUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Lost Keys (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='lostKeysEN'
                                      className='form-control mb-2'
                                      placeholder={t('Lost Keys')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setLostKeysEN(e.target.value)
                                        removeError('lostKeysEN')
                                      }}
                                      value={lostKeysEN}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>{error[0].lostKeysEN}</div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Lost Keys (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='lostKeysRU'
                                      className='form-control mb-2'
                                      placeholder={t('Lost Keys')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setLostKeysRU(e.target.value)
                                      }}
                                      value={lostKeysRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Lost Keys (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='lostKeysUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Lost Keys')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setLostKeysUZ(e.target.value)
                                      }}
                                      value={lostKeysUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Seat Belts (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='seatBeltsEN'
                                      className='form-control mb-2'
                                      placeholder={t('Seat Belts')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setSeatBeltsEN(e.target.value)
                                        removeError('seatBeltsEN')
                                      }}
                                      value={seatBeltsEN}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].seatBeltsEN}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Seat Belts (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='seatBeltsRU'
                                      className='form-control mb-2'
                                      placeholder={t('Seat Belts')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setSeatBeltsRU(e.target.value)
                                      }}
                                      value={seatBeltsRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Seat Belts (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='seatBeltsUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Seat Belts')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setSeatBeltsUZ(e.target.value)
                                      }}
                                      value={seatBeltsUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('No Smoking (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='noSmokingEN'
                                      className='form-control mb-2'
                                      placeholder={t('No Smoking')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setNoSmokingEN(e.target.value)
                                        removeError('noSmokingEN')
                                      }}
                                      value={noSmokingEN}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].noSmokingEN}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('No Smoking (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='noSmokingRU'
                                      className='form-control mb-2'
                                      placeholder={t('No Smoking')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setNoSmokingRU(e.target.value)
                                      }}
                                      value={noSmokingRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('No Smoking (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='noSmokingUZ'
                                      className='form-control mb-2'
                                      placeholder={t('No Smoking')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setNoSmokingUZ(e.target.value)
                                      }}
                                      value={noSmokingUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Price Calculation (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='priceCalculationEN'
                                      className='form-control mb-2'
                                      placeholder={t('Price Calculation')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setPriceCalculationEN(e.target.value)
                                        removeError('priceCalculationEN')
                                      }}
                                      value={priceCalculationEN}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].priceCalculationEN}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Price Calculation (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='priceCalculationRU'
                                      className='form-control mb-2'
                                      placeholder={t('Price Calculation')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setPriceCalculationRU(e.target.value)
                                      }}
                                      value={priceCalculationRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Price Calculation (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='priceCalculationUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Price Calculation')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setPriceCalculationUZ(e.target.value)
                                      }}
                                      value={priceCalculationUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Violations (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='violationsEN'
                                      className='form-control mb-2'
                                      placeholder={t('Violations')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setViolationsEN(e.target.value)
                                        removeError('violationsEN')
                                      }}
                                      value={violationsEN}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].violationsEN}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Violations (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='violationsRU'
                                      className='form-control mb-2'
                                      placeholder={t('Violations')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setViolationsRU(e.target.value)
                                      }}
                                      value={violationsRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Violations (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='violationsUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Violations')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setViolationsUZ(e.target.value)
                                      }}
                                      value={violationsUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Travel Restrictions (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='travelRestrictionsEN'
                                      className='form-control mb-2'
                                      placeholder={t('Travel Restrictions')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setTravelRestrictionsEN(e.target.value)
                                        removeError('travelRestrictionsEN')
                                      }}
                                      value={travelRestrictionsEN}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].travelRestrictionsEN}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Travel Restrictions (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='travelRestrictionsRU'
                                      className='form-control mb-2'
                                      placeholder={t('Travel Restrictions')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setTravelRestrictionsRU(e.target.value)
                                      }}
                                      value={travelRestrictionsRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Travel Restrictions (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='travelRestrictionsUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Travel Restrictions')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setTravelRestrictionsUZ(e.target.value)
                                      }}
                                      value={travelRestrictionsUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                              </>
                            )}
                            {primaryLanguage == 'Russian' && (
                              <>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Accidents & BreakDowns (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='accidentsAndBreakdownsRU'
                                      className='form-control mb-2'
                                      placeholder={t('Accidents & BreakDowns')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setAccidentsAndBreakdownsRU(e.target.value)
                                        removeError('accidentsAndBreakdownsRU')
                                      }}
                                      value={accidentsAndBreakdownsRU}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].accidentsAndBreakdownsRU}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Accidents & BreakDowns (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='accidentsAndBreakdownsEN'
                                      className='form-control mb-2'
                                      placeholder={t('Accidents & BreakDowns')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setAccidentsAndBreakdownsEN(e.target.value)
                                      }}
                                      value={accidentsAndBreakdownsEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Accidents & BreakDowns (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='accidentsAndBreakdownsUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Accidents & BreakDowns')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setAccidentsAndBreakdownsUZ(e.target.value)
                                      }}
                                      value={accidentsAndBreakdownsUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Roadside Assistance (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='roadsideAssistanceRU'
                                      className='form-control mb-2'
                                      placeholder={t('Roadside Assistance')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setRoadsideAssistanceRU(e.target.value)
                                        removeError('roadsideAssistanceRU')
                                      }}
                                      value={roadsideAssistanceRU}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].roadsideAssistanceRU}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Roadside Assistance (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='roadsideAssistanceEN'
                                      className='form-control mb-2'
                                      placeholder={t('Roadside Assistance')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setRoadsideAssistanceEN(e.target.value)
                                      }}
                                      value={roadsideAssistanceEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Roadside Assistance (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='roadsideAssistanceUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Roadside Assistance')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setRoadsideAssistanceUZ(e.target.value)
                                      }}
                                      value={roadsideAssistanceUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Lost Keys (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='lostKeysRU'
                                      className='form-control mb-2'
                                      placeholder={t('Lost Keys')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setLostKeysRU(e.target.value)
                                        removeError('lostKeysRU')
                                      }}
                                      value={lostKeysRU}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>{error[0].lostKeysRU}</div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Lost Keys (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='lostKeysEN'
                                      className='form-control mb-2'
                                      placeholder={t('Lost Keys')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setLostKeysEN(e.target.value)
                                      }}
                                      value={lostKeysEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Lost Keys (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='lostKeysUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Lost Keys')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setLostKeysUZ(e.target.value)
                                      }}
                                      value={lostKeysUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Seat Belts (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='seatBeltsRU'
                                      className='form-control mb-2'
                                      placeholder={t('Seat Belts')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setSeatBeltsRU(e.target.value)
                                        removeError('seatBeltsRU')
                                      }}
                                      value={seatBeltsRU}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].seatBeltsRU}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Seat Belts (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='seatBeltsEN'
                                      className='form-control mb-2'
                                      placeholder={t('Seat Belts')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setSeatBeltsEN(e.target.value)
                                      }}
                                      value={seatBeltsEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Seat Belts (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='seatBeltsUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Seat Belts')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setSeatBeltsUZ(e.target.value)
                                      }}
                                      value={seatBeltsUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('No Smoking (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='noSmokingRU'
                                      className='form-control mb-2'
                                      placeholder={t('No Smoking')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setNoSmokingRU(e.target.value)
                                        removeError('noSmokingRU')
                                      }}
                                      value={noSmokingRU}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].noSmokingRU}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('No Smoking (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='noSmokingEN'
                                      className='form-control mb-2'
                                      placeholder={t('No Smoking')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setNoSmokingEN(e.target.value)
                                      }}
                                      value={noSmokingEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('No Smoking (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='noSmokingUZ'
                                      className='form-control mb-2'
                                      placeholder={t('No Smoking')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setNoSmokingUZ(e.target.value)
                                      }}
                                      value={noSmokingUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Price Calculation (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='priceCalculationRU'
                                      className='form-control mb-2'
                                      placeholder={t('Price Calculation')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setPriceCalculationRU(e.target.value)
                                        removeError('priceCalculationRU')
                                      }}
                                      value={priceCalculationRU}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].priceCalculationRU}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Price Calculation (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='priceCalculationEN'
                                      className='form-control mb-2'
                                      placeholder={t('Price Calculation')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setPriceCalculationEN(e.target.value)
                                      }}
                                      value={priceCalculationEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Price Calculation (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='priceCalculationUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Price Calculation')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setPriceCalculationUZ(e.target.value)
                                      }}
                                      value={priceCalculationUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Violations (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='violationsRU'
                                      className='form-control mb-2'
                                      placeholder={t('Violations')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setViolationsRU(e.target.value)
                                        removeError('violationsRU')
                                      }}
                                      value={violationsRU}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].violationsRU}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Violations (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='violationsEN'
                                      className='form-control mb-2'
                                      placeholder={t('Violations')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setViolationsEN(e.target.value)
                                      }}
                                      value={violationsEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Violations (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='violationsUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Violations')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setViolationsUZ(e.target.value)
                                      }}
                                      value={violationsUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Travel Restrictions (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='travelRestrictionsRU'
                                      className='form-control mb-2'
                                      placeholder={t('Travel Restrictions')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setTravelRestrictionsRU(e.target.value)
                                        removeError('travelRestrictionsRU')
                                      }}
                                      value={travelRestrictionsRU}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].travelRestrictionsRU}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Travel Restrictions (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='travelRestrictionsEN'
                                      className='form-control mb-2'
                                      placeholder={t('Travel Restrictions')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setTravelRestrictionsEN(e.target.value)
                                      }}
                                      value={travelRestrictionsEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Travel Restrictions (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='travelRestrictionsUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Travel Restrictions')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setTravelRestrictionsUZ(e.target.value)
                                      }}
                                      value={travelRestrictionsUZ}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                              </>
                            )}
                            {primaryLanguage == 'Uzbek' && (
                              <>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Accidents & BreakDowns (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='accidentsAndBreakdownsUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Accidents & BreakDowns')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setAccidentsAndBreakdownsUZ(e.target.value)
                                        removeError('accidentsAndBreakdownsUZ')
                                      }}
                                      value={accidentsAndBreakdownsUZ}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].accidentsAndBreakdownsUZ}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Accidents & BreakDowns (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='accidentsAndBreakdownsRU'
                                      className='form-control mb-2'
                                      placeholder={t('Accidents & BreakDowns')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setAccidentsAndBreakdownsRU(e.target.value)
                                      }}
                                      value={accidentsAndBreakdownsRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Accidents & BreakDowns (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='accidentsAndBreakdownsEN'
                                      className='form-control mb-2'
                                      placeholder={t('Accidents & BreakDowns')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setAccidentsAndBreakdownsEN(e.target.value)
                                      }}
                                      value={accidentsAndBreakdownsEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Roadside Assistance (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='roadsideAssistanceUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Roadside Assistance')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setRoadsideAssistanceUZ(e.target.value)
                                        removeError('roadsideAssistanceUZ')
                                      }}
                                      value={roadsideAssistanceUZ}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].roadsideAssistanceUZ}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Roadside Assistance (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='roadsideAssistanceRU'
                                      className='form-control mb-2'
                                      placeholder={t('Roadside Assistance')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setRoadsideAssistanceRU(e.target.value)
                                      }}
                                      value={roadsideAssistanceRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Roadside Assistance (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='roadsideAssistanceEN'
                                      className='form-control mb-2'
                                      placeholder={t('Roadside Assistance')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setRoadsideAssistanceEN(e.target.value)
                                      }}
                                      value={roadsideAssistanceEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Lost Keys (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='lostKeysUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Lost Keys')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setLostKeysUZ(e.target.value)
                                        removeError('lostKeysUZ')
                                      }}
                                      value={lostKeysUZ}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>{error[0].lostKeysUZ}</div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Lost Keys (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='lostKeysRU'
                                      className='form-control mb-2'
                                      placeholder={t('Lost Keys')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setLostKeysRU(e.target.value)
                                      }}
                                      value={lostKeysRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Lost Keys (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='lostKeysEN'
                                      className='form-control mb-2'
                                      placeholder={t('Lost Keys')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setLostKeysEN(e.target.value)
                                      }}
                                      value={lostKeysEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Seat Belts (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='seatBeltsUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Seat Belts')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setSeatBeltsUZ(e.target.value)
                                        removeError('seatBeltsUZ')
                                      }}
                                      value={seatBeltsUZ}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].seatBeltsUZ}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Seat Belts (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='seatBeltsRU'
                                      className='form-control mb-2'
                                      placeholder={t('Seat Belts')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setSeatBeltsRU(e.target.value)
                                      }}
                                      value={seatBeltsRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Seat Belts (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='seatBeltsEN'
                                      className='form-control mb-2'
                                      placeholder={t('Seat Belts')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setSeatBeltsEN(e.target.value)
                                      }}
                                      value={seatBeltsEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('No Smoking (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='noSmokingUZ'
                                      className='form-control mb-2'
                                      placeholder={t('No Smoking')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setNoSmokingUZ(e.target.value)
                                        removeError('noSmokingUZ')
                                      }}
                                      value={noSmokingUZ}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].noSmokingUZ}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('No Smoking (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='noSmokingRU'
                                      className='form-control mb-2'
                                      placeholder={t('No Smoking')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setNoSmokingRU(e.target.value)
                                      }}
                                      value={noSmokingRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('No Smoking (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='noSmokingEN'
                                      className='form-control mb-2'
                                      placeholder={t('No Smoking')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setNoSmokingEN(e.target.value)
                                      }}
                                      value={noSmokingEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Price Calculation (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='priceCalculationUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Price Calculation')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setPriceCalculationUZ(e.target.value)
                                        removeError('priceCalculationUZ')
                                      }}
                                      value={priceCalculationUZ}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].priceCalculationUZ}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Price Calculation (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='priceCalculationRU'
                                      className='form-control mb-2'
                                      placeholder={t('Price Calculation')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setPriceCalculationRU(e.target.value)
                                      }}
                                      value={priceCalculationRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Price Calculation (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='priceCalculationEN'
                                      className='form-control mb-2'
                                      placeholder={t('Price Calculation')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setPriceCalculationEN(e.target.value)
                                      }}
                                      value={priceCalculationEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Violations (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='violationsUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Violations')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setViolationsUZ(e.target.value)
                                        removeError('violationsUZ')
                                      }}
                                      value={violationsUZ}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].violationsUZ}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Violations (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='violationsRU'
                                      className='form-control mb-2'
                                      placeholder={t('Violations')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setViolationsRU(e.target.value)
                                      }}
                                      value={violationsRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Violations (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='violationsEN'
                                      className='form-control mb-2'
                                      placeholder={t('Violations')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setViolationsEN(e.target.value)
                                      }}
                                      value={violationsEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 required form-label'>
                                      {t('Travel Restrictions (Uzbek)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='travelRestrictionsUZ'
                                      className='form-control mb-2'
                                      placeholder={t('Travel Restrictions')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setTravelRestrictionsUZ(e.target.value)
                                        removeError('travelRestrictionsUZ')
                                      }}
                                      value={travelRestrictionsUZ}
                                    ></textarea>
                                    <div className='text-danger fw-bold'>
                                      {error[0].travelRestrictionsUZ}
                                    </div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Travel Restrictions (Russian)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='travelRestrictionsRU'
                                      className='form-control mb-2'
                                      placeholder={t('Travel Restrictions')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setTravelRestrictionsRU(e.target.value)
                                      }}
                                      value={travelRestrictionsRU}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='fs-4 form-label'>
                                      {t('Travel Restrictions (English)')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <textarea
                                      name='travelRestrictionsEN'
                                      className='form-control mb-2'
                                      placeholder={t('Travel Restrictions')}
                                      cols={30}
                                      rows={4}
                                      onChange={(e) => {
                                        setTravelRestrictionsEN(e.target.value)
                                      }}
                                      value={travelRestrictionsEN}
                                    ></textarea>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                              </>
                            )}
                            <div className='row'>
                              <div className='col-lg-12 my-3 d-flex justify-content-end'>
                                <button
                                  className='btn btn-light-success mx-1'
                                  onClick={() => setTab('5')}
                                >
                                  {t('Back')}
                                </button>
                                <button className='btn btn-success mx-1' onClick={nextToTab7}>
                                  {t('Next')}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='tab-content'>
                          <div className={clsx('tab-pane', {active: tab === '7'})}>
                            <div className='row'>
                              <div className='col-lg-12 my-3'>
                                <button className='btn btn-light-success' onClick={togglePolicy}>
                                  {t('Add Custom Policy')}
                                </button>
                              </div>
                            </div>
                            {showPolicy &&
                              policies.map((policy, index) => (
                                <div className='row' key={index}>
                                  {primaryLanguage == 'English' && (
                                    <>
                                      <div className='col-lg-12'>
                                        <div className='row'>
                                          <div className='col-lg my-3'>
                                            <label className='required fs-4 form-label'>
                                              {t('Policy Title (English)')}
                                            </label>
                                            <input
                                              type='text'
                                              name='titleEN'
                                              placeholder={t('Policy Title')}
                                              className='form-control mb-2'
                                              value={policy.en_title}
                                              onChange={(e) =>
                                                handlePolicyChange(
                                                  index,
                                                  'en_title',
                                                  e.target.value
                                                )
                                              }
                                            />
                                            {errors[index]?.titleEN && (
                                              <div className='text-danger fw-bold'>
                                                {errors[index].titleEN}
                                              </div>
                                            )}
                                          </div>
                                          <div className='col-lg my-3'>
                                            <label className='fs-4 form-label'>
                                              {t('Policy Title (Russian)')}
                                            </label>
                                            <input
                                              type='text'
                                              name='titleRU'
                                              placeholder={t('Policy Title')}
                                              className='form-control mb-2'
                                              value={policy.ru_title}
                                              onChange={(e) =>
                                                handlePolicyChange(
                                                  index,
                                                  'ru_title',
                                                  e.target.value
                                                )
                                              }
                                            />
                                          </div>
                                          <div className='col-lg my-3'>
                                            <label className=' fs-4 form-label'>
                                              {t('Policy Title (Uzbek)')}
                                            </label>
                                            <input
                                              type='text'
                                              name='titleUZ'
                                              placeholder={t('Policy Title')}
                                              className='form-control mb-2'
                                              value={policy.uz_title}
                                              onChange={(e) =>
                                                handlePolicyChange(
                                                  index,
                                                  'uz_title',
                                                  e.target.value
                                                )
                                              }
                                            />
                                          </div>
                                          <div className='col-lg-2'></div>
                                        </div>
                                        <div className='row'>
                                          <div className='col-lg my-3'>
                                            <label className='required fs-4 form-label'>
                                              {t('Description (English)')}
                                            </label>
                                            <textarea
                                              name='descriptionEN'
                                              className='form-control mb-2'
                                              placeholder={t('Description')}
                                              cols={30}
                                              rows={4}
                                              value={policy.en_description}
                                              onChange={(e) =>
                                                handlePolicyChange(
                                                  index,
                                                  'en_description',
                                                  e.target.value
                                                )
                                              }
                                            ></textarea>
                                            {errors[index]?.descriptionEN && (
                                              <div className='text-danger fw-bold'>
                                                {errors[index].descriptionEN}
                                              </div>
                                            )}
                                          </div>
                                          <div className='col-lg my-3'>
                                            <label className='fs-4 form-label'>
                                              {t('Description (Russian)')}
                                            </label>
                                            <textarea
                                              name='descriptionRU'
                                              className='form-control mb-2'
                                              placeholder={t('Description')}
                                              cols={30}
                                              rows={4}
                                              value={policy.ru_description}
                                              onChange={(e) =>
                                                handlePolicyChange(
                                                  index,
                                                  'ru_description',
                                                  e.target.value
                                                )
                                              }
                                            ></textarea>
                                          </div>
                                          <div className='col-lg my-3'>
                                            <label className='fs-4 form-label'>
                                              {t('Description (Uzbek)')}
                                            </label>
                                            <textarea
                                              name='descriptionUZ'
                                              className='form-control mb-2'
                                              placeholder={t('Description')}
                                              cols={30}
                                              rows={4}
                                              value={policy.uz_description}
                                              onChange={(e) =>
                                                handlePolicyChange(
                                                  index,
                                                  'uz_description',
                                                  e.target.value
                                                )
                                              }
                                            ></textarea>
                                          </div>
                                          <div className='col-lg-2 d-flex justify-content-lg-start justify-content-end align-items-end my-3'>
                                            {index !== 0 && (
                                              <button
                                                className='btn btn-danger mb-2 me-1'
                                                onClick={() => handleRemovePolicy(index)}
                                              >
                                                X
                                              </button>
                                            )}
                                            <button
                                              className='btn btn-success mb-2'
                                              onClick={handleAddPolicy}
                                            >
                                              +
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  )}
                                  {primaryLanguage == 'Russian' && (
                                    <>
                                      <div className='col-lg-12'>
                                        <div className='row'>
                                          <div className='col-lg my-3'>
                                            <label className='required fs-4 form-label'>
                                              {t('Policy Title (Russian)')}
                                            </label>
                                            <input
                                              type='text'
                                              name='titleRU'
                                              placeholder={t('Policy Title')}
                                              className='form-control mb-2'
                                              value={policy.ru_title}
                                              onChange={(e) =>
                                                handlePolicyChange(
                                                  index,
                                                  'ru_title',
                                                  e.target.value
                                                )
                                              }
                                            />
                                            {errors[index]?.titleRU && (
                                              <div className='text-danger fw-bold'>
                                                {errors[index].titleRU}
                                              </div>
                                            )}
                                          </div>
                                          <div className='col-lg my-3'>
                                            <label className='fs-4 form-label'>
                                              {t('Policy Title (English)')}
                                            </label>
                                            <input
                                              type='text'
                                              name='titleEN'
                                              placeholder={t('Policy Title')}
                                              className='form-control mb-2'
                                              value={policy.en_title}
                                              onChange={(e) =>
                                                handlePolicyChange(
                                                  index,
                                                  'en_title',
                                                  e.target.value
                                                )
                                              }
                                            />
                                          </div>
                                          <div className='col-lg my-3'>
                                            <label className='fs-4 form-label'>
                                              {t('Policy Title (Uzbek)')}
                                            </label>
                                            <input
                                              type='text'
                                              name='titleUZ'
                                              placeholder={t('Policy Title')}
                                              className='form-control mb-2'
                                              value={policy.uz_title}
                                              onChange={(e) =>
                                                handlePolicyChange(
                                                  index,
                                                  'uz_title',
                                                  e.target.value
                                                )
                                              }
                                            />
                                          </div>
                                          <div className='col-lg-2'></div>
                                        </div>
                                        <div className='row'>
                                          <div className='col-lg my-3'>
                                            <label className='required fs-4 form-label'>
                                              {t('Description (Russian)')}
                                            </label>
                                            <textarea
                                              name='descriptionRU'
                                              className='form-control mb-2'
                                              placeholder={t('Description')}
                                              cols={30}
                                              rows={4}
                                              value={policy.ru_description}
                                              onChange={(e) =>
                                                handlePolicyChange(
                                                  index,
                                                  'ru_description',
                                                  e.target.value
                                                )
                                              }
                                            ></textarea>
                                            {errors[index]?.descriptionRU && (
                                              <div className='text-danger fw-bold'>
                                                {errors[index].descriptionRU}
                                              </div>
                                            )}
                                          </div>
                                          <div className='col-lg my-3'>
                                            <label className='fs-4 form-label'>
                                              {t('Description (English)')}
                                            </label>
                                            <textarea
                                              name='descriptionEN'
                                              className='form-control mb-2'
                                              placeholder={t('Description')}
                                              cols={30}
                                              rows={4}
                                              value={policy.en_description}
                                              onChange={(e) =>
                                                handlePolicyChange(
                                                  index,
                                                  'en_description',
                                                  e.target.value
                                                )
                                              }
                                            ></textarea>
                                          </div>
                                          <div className='col-lg my-3'>
                                            <label className='fs-4 form-label'>
                                              {t('Description (Uzbek)')}
                                            </label>
                                            <textarea
                                              name='descriptionUZ'
                                              className='form-control mb-2'
                                              placeholder={t('Description')}
                                              cols={30}
                                              rows={4}
                                              value={policy.uz_description}
                                              onChange={(e) =>
                                                handlePolicyChange(
                                                  index,
                                                  'uz_description',
                                                  e.target.value
                                                )
                                              }
                                            ></textarea>
                                          </div>
                                          <div className='col-lg-2 d-flex justify-content-lg-start justify-content-end align-items-end my-3'>
                                            {index !== 0 && (
                                              <button
                                                className='btn btn-danger mb-2 me-1'
                                                onClick={() => handleRemovePolicy(index)}
                                              >
                                                X
                                              </button>
                                            )}
                                            <button
                                              className='btn btn-success mb-2'
                                              onClick={handleAddPolicy}
                                            >
                                              +
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  )}
                                  {primaryLanguage == 'Uzbek' && (
                                    <>
                                      <div className='col-lg-12'>
                                        <div className='row'>
                                          <div className='col-lg my-3'>
                                            <label className='fs-4 form-label required'>
                                              {t('Policy Title (Uzbek)')}
                                            </label>
                                            <input
                                              type='text'
                                              name='titleUZ'
                                              placeholder={t('Policy Title')}
                                              className='form-control mb-2'
                                              value={policy.uz_title}
                                              onChange={(e) =>
                                                handlePolicyChange(
                                                  index,
                                                  'uz_title',
                                                  e.target.value
                                                )
                                              }
                                            />
                                            {errors[index]?.titleUZ && (
                                              <div className='text-danger fw-bold'>
                                                {errors[index].titleUZ}
                                              </div>
                                            )}
                                          </div>
                                          <div className='col-lg my-3'>
                                            <label className=' fs-4 form-label'>
                                              {t('Policy Title (Russian)')}
                                            </label>
                                            <input
                                              type='text'
                                              name='titleRU'
                                              placeholder={t('Policy Title')}
                                              className='form-control mb-2'
                                              value={policy.ru_title}
                                              onChange={(e) =>
                                                handlePolicyChange(
                                                  index,
                                                  'ru_title',
                                                  e.target.value
                                                )
                                              }
                                            />
                                          </div>
                                          <div className='col-lg my-3'>
                                            <label className='fs-4 form-label'>
                                              {t('Policy Title (English)')}
                                            </label>
                                            <input
                                              type='text'
                                              name='titleEN'
                                              placeholder={t('Policy Title')}
                                              className='form-control mb-2'
                                              value={policy.en_title}
                                              onChange={(e) =>
                                                handlePolicyChange(
                                                  index,
                                                  'en_title',
                                                  e.target.value
                                                )
                                              }
                                            />
                                          </div>
                                          <div className='col-lg-2'></div>
                                        </div>
                                        <div className='row'>
                                          <div className='col-lg my-3'>
                                            <label className='required fs-4 form-label'>
                                              {t('Description (Uzbek)')}
                                            </label>
                                            <textarea
                                              name='descriptionUZ'
                                              className='form-control mb-2'
                                              placeholder={t('Description')}
                                              cols={30}
                                              rows={4}
                                              value={policy.uz_description}
                                              onChange={(e) =>
                                                handlePolicyChange(
                                                  index,
                                                  'uz_description',
                                                  e.target.value
                                                )
                                              }
                                            ></textarea>
                                            {errors[index]?.descriptionUZ && (
                                              <div className='text-danger fw-bold'>
                                                {errors[index].descriptionUZ}
                                              </div>
                                            )}
                                          </div>
                                          <div className='col-lg my-3'>
                                            <label className='fs-4 form-label'>
                                              {t('Description (Russian)')}
                                            </label>
                                            <textarea
                                              name='descriptionRU'
                                              className='form-control mb-2'
                                              placeholder={t('Description')}
                                              cols={30}
                                              rows={4}
                                              value={policy.ru_description}
                                              onChange={(e) =>
                                                handlePolicyChange(
                                                  index,
                                                  'ru_description',
                                                  e.target.value
                                                )
                                              }
                                            ></textarea>
                                          </div>
                                          <div className='col-lg my-3'>
                                            <label className='fs-4 form-label'>
                                              {t('Description (English)')}
                                            </label>
                                            <textarea
                                              name='descriptionEN'
                                              className='form-control mb-2'
                                              placeholder={t('Description')}
                                              cols={30}
                                              rows={4}
                                              value={policy.en_description}
                                              onChange={(e) =>
                                                handlePolicyChange(
                                                  index,
                                                  'en_description',
                                                  e.target.value
                                                )
                                              }
                                            ></textarea>
                                          </div>
                                          <div className='col-lg-2 d-flex justify-content-lg-start justify-content-end align-items-end my-3'>
                                            {index !== 0 && (
                                              <button
                                                className='btn btn-danger mb-2 me-1'
                                                onClick={() => handleRemovePolicy(index)}
                                              >
                                                X
                                              </button>
                                            )}
                                            <button
                                              className='btn btn-success mb-2'
                                              onClick={handleAddPolicy}
                                            >
                                              +
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  )}
                                </div>
                              ))}
                            <div className='row'>
                              <div className='col-lg-12 my-3 d-flex justify-content-end'>
                                <button
                                  className='btn btn-light-success mx-1'
                                  onClick={() => setTab('6')}
                                >
                                  {t('Back')}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <!--begin::Card body--> */}
                    </div>
                    {/* <!--end::Pricing--> */}
                  </div>
                </div>
                {/* <!--end::Tab pane--> */}
              </div>
              {/* <!--end::Tab content--> */}
              {tab == '7' && (
                <div className='d-flex justify-content-end'>
                  <button
                    type='button'
                    disabled={disable}
                    className='btn btn-primary'
                    onClick={AddCarRentalPolicies}
                  >
                    <span className='indicator-label'>{t('Submit')}</span>
                    {loading && (
                      <span
                        className='spinner-border spinner-border-sm mx-2'
                        role='status'
                        aria-hidden='true'
                      ></span>
                    )}
                  </button>
                  {/* <!--end::Button--> */}
                </div>
              )}
            </div>
            {/* <!--end::Main column--> */}
          </div>
          {/* <!--end::Form--> */}
        </div>
        {/* <!--end::Content--> */}
      </div>
    </>
  )
}

export {AddCarRentalPolicies}
